$.ajaxSetup({
	timeout:1200000
});
function getGraphData(){
	if(isTour && tourStep == 3){
		$.powerTour('end');
	}
	var from = $('#from').datepicker('getDate');
	var to = $('#to').datepicker('getDate');
	$('.pop_up.load').show();

	if(!isInit && (mainGraphFilter == 'lengthofstay' || mainGraphFilter == 'lengthofstaytotal')){
		if(from.getMonth() == to.getMonth()){
			isWithinMonth = true;
		}else{
			isWithinMonth = false;
		}
		checkIfChangePayResidents();
	}

	var link = '/analytics/getGraphData';
	if(monthDiff(from, to) <= 1){
		from.setMonth(from.getMonth() - 1);
	}
	var fromUNIX = from.getTime() / 1000;
	var toUNIX = to.getTime() / 1000;

	passData = {
		from: fromUNIX, 
		to: toUNIX,
		chartType: mainGraphFilter	
	};

	if(usr_assoc_id != ''){
		passData['usr_assoc_id'] = usr_assoc_id;
	}

	getGraph = $.getJSON(link, passData, function(data){
		removedData = [];
		notRemovedData = [];
		graphData = data['graphData'];
		rawRate = data['rawRate'];
		adjustedRate = data['adjustedRate'];
		bedCount = (data['bedCount'] ? data['bedCount'] : 0);
		totalIndicators = data['totalIndicators'];
		if(data['indicators'] != undefined){
			indicatorData = data['indicators']['regular'];
			surveyData = data['indicators']['survey'];
			qisData = data['indicators']['QIS'];
		}else{
			indicatorData = [];
		}

		if(isInit){
			getCompareData(false, function(){setCorrectGraphInformation();}); //only need to load this once
			isInit = false;
		}
				

		var fromDate = $('#from').datepicker('getDate');
		var toDate = $('#to').datepicker('getDate');
		fromDate = padDate((fromDate.getMonth() + 1))+'-'+padDate(fromDate.getDate())+'-'+fromDate.getFullYear().toString().substr(2,2);
		toDate = padDate((toDate.getMonth() + 1))+'-'+padDate(toDate.getDate())+'-'+toDate.getFullYear().toString().substr(2,2);
		$('#dateTexts').html('<b>FROM:</b> '+fromDate+' <b>TO:</b> '+toDate);
		customFilterValues.months.setup();
		$('.d3-tip').css({ opacity: 0, 'pointer-events': 'none', 'display': 'none' });
		if(mainGraphFilter != ''){
			generateGraphs();
		}else{
			if(mainGraphFilter == 'census' && (graphType == 'Pie' || graphType == 'Doughnut')){
				generateGraphs();
			}else{
				generateGraphs(false, true);
			}
		}
		$('.pop_up.load, .overlay').hide();
		if(isTour && tourStep == 15){
			$.powerTour('navigation', ["goto", 16]);
		}
	});
}

function getCompareData(reload, callback, zip){
	if(reload == undefined){reload = false;}
	if(callback == undefined){callback = function(){};}
	comparePie = null;
	$('.pie-load').empty().append('<div class="loader"></div>');
	$('.pie-load').show();
	$('#comparestar-chart svg').remove();
	var passData = {
		local: (thisFacilityData.length !== 0 ? false : true),
		range: nearbyRange
	};
	if(zip !== false && zip != undefined){
		passData['zip'] = zip+'::';
		if(zip in newLocal){
			passData['zip'] = zip+'::'+newLocal[zip].readable.city+'::'+newLocal[zip].readable.county+'::'+newLocal[zip].readable.state;
		}
	}
	if(usr_assoc_id != ''){
		//passData['usr_assoc_id'] = usr_assoc_id;
	}
	$.getJSON('/analytics/getComparisonData', passData, function(data){
		compareData = [];
		if(data.nearbyFacilities != 'error' && data.nearbyFacilities != 'No Results'){
			if(data.length != 0){
				compareData = data.nearbyFacilities;
				if(isNumeric(data.range)){
					nearbyRange = parseInt(data.range);
					distanceRatings[0].key = nearbyRange;
				}
				for(var i = 0; i < compareData.length; i++){
					if(!('overall_rating' in compareData[i]) || !('health_inspection_rating' in compareData[i]) || !('qm_rating' in compareData[i]) || !('rn_staffing_rating' in compareData[i]) || compareData[i].overall_rating == undefined || compareData[i].health_inspection_rating == undefined || compareData[i].qm_rating == undefined || compareData[i].rn_staffing_rating == undefined){
						compareData.splice(i,1);
						if(i != 0){
							i--;
						}
					}
				}
			}
		}else if(data.nearbyFacilities == 'No Results'){
			compareData = [];
			if(isNumeric(data.range)){
				nearbyRange = parseInt(data.range);
				distanceRatings[0].key = nearbyRange;
			}
		}else{
			compareData = [];
			if(isNumeric(data.range)){
				nearbyRange = parseInt(data.range);
				distanceRatings[0].key = nearbyRange;
			}
		}
		if(data.length != 0){
			if('local' in data && data.local != false){
				thisFacilityData = data.local;
				data.local['isLocal'] = true;
				data.local['realState'] = data.local['state'];
				data.local['realCounty'] = data.local['county'];
				compareData.push(data.local);
			}else if(thisFacilityData.length != 0){
				compareData.push(thisFacilityData);
			}
		}
		if(reload){
			generateGraphs(true);
		}else{
			createCMSPies();
		}
		callback();
		$('.pie-load').hide();
	});
}

function chartPostRenderPositioning(selection, get, forceHeightDivision){
	var isAccumlative = false;
	if(get instanceof Object){
		isAccumlative = true;
	}
	var modifySVGBars = d3.select(mainChart.svg()[0][0]);
	var barHeights = {};
	var monthPlotPoints = {};
	modifySVGBars.select(selection).selectAll('g').selectAll('.bar').each(function(){
		var self = d3.select(this);
		var height = self.attr('height');
		var x = self.attr('x');
		var width = self.attr('width');
		var data = this.__data__.data;
		if(!(monthFormat(data.key) in barHeights)){
			barHeights[monthFormat(data.key)] = {height: 0, x: 0, count: 0, width: 0};
			if(!isAccumlative){
				barHeights[monthFormat(data.key)].value = data.value[get];
			}
		}
		barHeights[monthFormat(data.key)].count++;
		barHeights[monthFormat(data.key)].height += parseFloat(height);
		barHeights[monthFormat(data.key)].x = x;
		barHeights[monthFormat(data.key)].width = parseFloat(width);
	});
	if(isAccumlative){
		for(var month in get){
			if(month in barHeights){
				get[month].height = barHeights[month].height;
				if(graphType != 'Bar'){
					get[month].height = barHeights[month].height / barHeights[month].count;
				}
				get[month].x = barHeights[month].x;
				get[month].width = barHeights[month].width;
			}
		}
		if(mainChart.selectAll('svg').select('.bar-text').length > 0){
			mainChart.selectAll('svg').select('.bar-text').remove();
		}
		return get;
	}else{
		var returnMonthObject = barHeights;
		for(var month in barHeights){
			if(!(month in returnMonthObject)){
				returnMonthObject[month] = barHeights[month];
			}
			if(graphType != 'Bar' || forceHeightDivision){
				returnMonthObject[month].height = barHeights[month].height / barHeights[month].count;
			}
		}
		if(mainChart.selectAll('svg').select('.bar-text').length > 0){
			mainChart.selectAll('svg').select('.bar-text').remove();
		}
		return returnMonthObject;
	}
}

function basePostRender(get, ignoreBar, forceHeightDivision){
	var appendVariables = {monthCount: monthDiff($('#from').datepicker('getDate'), $('#to').datepicker('getDate'))};
	if(graphType == 'Bar' && !ignoreBar){
		appendVariables.chartBodyHeight = mainChart.selectAll('svg').select('.chart-body').node().getBBox().height;
		appendVariables.monthObject = chartPostRenderPositioning('.chart-body', get, forceHeightDivision);
		appendVariables.barTexts = mainChart.selectAll('svg').append('g').attr('class', 'bar-text').style('font-size', '12px').attr('transform', 'translate(30, 30)');
	}else if(graphType == 'Line' || graphType == 'Area' || ignoreBar){
		appendVariables.monthObject = chartPostRenderPositioning('circle.dot', get, forceHeightDivision);
		appendVariables.barTexts = mainChart.selectAll('svg').append('g').attr('class', 'bar-text').style('font-size', (appendVariables.monthCount <= 5 ? '12px' : '10px')).attr('transform', 'translate(30, 220)');
		appendVariables.xHeight = mainChart.selectAll('svg').select('.axis.x').node().getBBox().height;
		mainChart.selectAll('svg').select('.axis.x').selectAll('.tick').each(function(){
			var self = d3.select(this);
			var translate = self.attr('transform').match(/[\d.]+/g)[0];
			var month = monthFormat(this.__data__);
			if(month in appendVariables.monthObject){
				appendVariables.monthObject[month].width = translate;
			}
		});
	}
	return appendVariables;  
}

function setSimplePostRender(get, percent, textBefore, textAfter, value){
	value = (value != undefined ? value : 'value');
	var variables = basePostRender(get, false, false);
	if(graphType == 'Bar'){
		for(var month in variables.monthObject){
			if(variables.monthObject[month][value] * (percent ? 100 : 1) == 0){continue;}
			variables.barTexts.append('g').attr('transform', 'translate('+((variables.monthObject[month].width / 2) + 12)+', '+(variables.chartBodyHeight - variables.monthObject[month].height - 5)+')').append('text').attr('y', 0).attr('x', variables.monthObject[month].x).attr('text-anchor', 'middle').text(textBefore+formatPostNumber(variables.monthObject[month][value] * (percent ? 100 : 1)));
		}
	}else if(graphType == 'Line' || graphType == 'Area'){
		for(var month in variables.monthObject){
			if(variables.monthObject[month][value] * (percent ? 100 : 1) == 0){continue;}
			variables.barTexts.append('g').attr('transform', 'translate('+(variables.monthObject[month].width)+', '+(variables.xHeight + 12)+')').append('text').attr('y', 0).attr('x', variables.monthObject[month].x).attr('text-anchor', 'middle').text(textBefore+formatPostNumber(variables.monthObject[month][value] * (percent ? 100 : 1)));
		}
	}
}

function formatPostNumber(number){
	if(Math.trunc(number).toString().length == 3){
		number = number.toFixed();
	}
	if(Math.trunc(number).toString().length == 2) {
		number = number.toFixed(1);
	}
	if(Math.trunc(number).toString().length == 1) {
		number = number.toFixed(2);
	}
	return number; 
}

function accumlativePostRender(accumlativeObject, percent, textBefore, textAfter, value){
	var variables = basePostRender(accumlativeObject, true, true);
	for(var month in variables.monthObject){
		variables.barTexts.append('g').attr('transform', 'translate('+(variables.monthObject[month].width)+', '+(variables.xHeight + 12)+')').append('text').attr('y', 0).attr('x', variables.monthObject[month].x).attr('text-anchor', 'middle').text(textBefore+formatPostNumber(variables.monthObject[month][value] * (percent ? 100 : 1)));
	}
}

function setCorrectGraphInformation(){
	if(graphData == null || graphData.length == 0) return;
	var infoList = $('#percents > ul').show();
	$('#dateTexts, #daterange').show();
	var table = $('#percents > table').hide().removeClass('indicators');
	var tableHead = table.find('thead tr').empty();
	var tableBody = table.find('tbody').empty();
	var currFilters = $('#currentFilters').hide();
	$('#percents p#meaning').remove();
	$('#percents > ul li').remove();
	$('#graphSubtitle').text('');
	if(getGraph.progress().status != 200){
		return;
	}
	var from = $('#from').datepicker('getDate');
	from.setDate(from.getDate()-1);
	var to = $('#to').datepicker('getDate');
	var daysBetweenDates = Math.round(Math.abs((to.getTime() - from.getTime())/(oneDay)));
	var paytypes = financialChart.group().all();
	var infoListValues = [];
	var subtitle = '';
	mainChartPostRenderFunction = function(){};
	if(mainGraphFilter == 'admissions'){
		var colors = getPieColors(admissionsChart).values;
		var currentFilters = admissionsChart.filters();
		currentFilters = currentFilters.concat(dischargesChart.filters()).concat(financialChart.filters());
		if(censusChart != undefined){
			currentFilters.concat(censusChart.filters());
		}
		var total = 0;
		paytypes.forEach(function(d){
			var set = {}
			set['name'] = d.key;
			set['total'] = d.value;
			if(currentFilters.length != 0){
				if(currentFilters.indexOf(set.name) !== -1){
					infoListValues.push(set);
					total += set.total;
				}
			}else{
				infoListValues.push(set);
				total += set.total;
			}
		});
		infoListValues.forEach(function(d){
			if(d.total == 0){
				return;
			}
			subtitle += d.name+', ';
			infoList.append('<li class="'+(d.name in colors ? '_'+colors[d.name].substr(1, (colors[d.name].length - 1)) : '')+'"><b>'+d.name+'</b>: <b>'+d.total+'</b> or <b>'+((d.total / total) * 100).toFixed(2)+'%</b> </li>');
		});
		infoList.append('<li><b>ALL</b> admissions: <b>'+total+'</b>');
		if(currentFilters.length != 0){
			$('#graphSubtitle').text(subtitle.substr(0, (subtitle.length - 2))+ ' ADMISSIONS BY '+(isWithinMonth ? 'DAY' : 'MONTH'));
		}else{
			$('#graphSubtitle').text((isWithinMonth ? 'DAILY' : 'MONTHLY')+' ADMISSIONS BY PAYTYPE');
		}
	}else if(mainGraphFilter == 'discharges'){
		var colors = getPieColors(dischargesChart).values;
		var currentFilters = dischargesChart.filters();
		currentFilters = currentFilters.concat(admissionsChart.filters()).concat(financialChart.filters());
		if(censusChart != undefined){
			currentFilters.concat(censusChart.filters());
		}
		var total = 0;
		paytypes.forEach(function(d){
			var set = {}
			set['name'] = d.key;
			set['total'] = d.value;
			if(currentFilters.length != 0){
				if(currentFilters.indexOf(set.name) !== -1){
					infoListValues.push(set);
					total += set.total;
				}
			}else{
				infoListValues.push(set);
				total += set.total;
			}
		});
		infoListValues.forEach(function(d){
			if(d.total == 0){
				return;
			}
			subtitle += d.name+', ';
			infoList.append('<li class="'+(d.name in colors ? '_'+colors[d.name].substr(1, (colors[d.name].length - 1)) : '')+'"><b>'+d.name+'</b>: <b>'+d.total+'</b> or <b>'+((d.total / total) * 100).toFixed(2)+'%</b></li>');
		});
		infoList.append('<li><b>ALL</b> discharges: <b>'+total+'</b>');
		if(currentFilters.length != 0){
			$('#graphSubtitle').text(subtitle.substr(0, (subtitle.length - 2))+ ' '+(isWithinMonth ? 'DAILY' : 'MONTHLY')+' DISCHARGES BY PAYTYPE');
		}else{
			$('#graphSubtitle').text((isWithinMonth ? 'DAILY' : 'MONTHLY')+' DISCHARGES BY PAYTYPE');
		}

	}else if(mainGraphFilter == 'lengthofstay' || mainGraphFilter == 'lengthofstaytotal'){
		var monthCount = monthDiff($('#from').datepicker('getDate'), $('#to').datepicker('getDate'));
		var isTwoMonths = (monthCount == 2 ? true : false);
		var colors = getPieColors((losType == 'los' ? lengthofstaytotalChart : lengthofstayChart)).values;
		var mainChartAll = [];
		if(mainChart.allGroups == undefined){
			paytypeFunction = function(PayArray){
				var sorted = Object.keys(PayArray).sort(function(a,b){return b - a});
				return PayArray[sorted[0]];
			}
			var paytypes = getPaytypes();
			for(var i = 0; i < paytypes.length; i++){
				var fakeGroup = mainDimension.group().reduce(
					function(p,v){
						if(paytypeFunction(v.financial_change) == paytypes[i]){
							p.count++;
							p.type = paytypes[i];
							p.los += v.LOS;
							p.avgLOS = p.count ? (p.los / p.count) : 0;
						}
						return p;
					},
					function(p,v){
						if(paytypeFunction(v.financial_change) == paytypes[i]){
							p.count--;
							p.los -= v.LOS;
							p.avgLOS = p.count ? (p.los / p.count) : 0;
						}
						return p;
					},
					function(){
						return {
							count: 0,
							type: '',
							los: 0,
							avgLOS: 0
						};
					}
				);
				fakeGroup.all().forEach(function(d){
					mainChartAll.push(d);
				});
				fakeGroup.dispose();
			};
		}else{
			mainChart.allGroups().forEach(function(d){
				d.all().forEach(function(a){
					mainChartAll.push(a);
				})
			});
		}
		var currentMonth = {};
		var previousMonths = {};
		var totalChangeForMonths = {};
		mainChartAll.forEach(function(d){
			if(d.value.type == undefined || d.value.type == "") return;
			var firstDayOfMonth = new Date(d.key);
			var lastDayOfMonth = new Date(firstDayOfMonth.getFullYear(), firstDayOfMonth.getMonth() + 1, 0);
			firstDayOfMonth.setDate(firstDayOfMonth.getDate()-1); //fixes first day so we include it
			var monthDays = Math.round(Math.abs((lastDayOfMonth.getTime() - firstDayOfMonth.getTime())/(oneDay)));

			if(monthFormat(d.key) != monthFormat(to)){
				if(!(d.value.type in previousMonths)){
					previousMonths[d.value.type] = {name: d.value.type, avgLOS: 0, avgPercent: 0, count: 0, days: 0, los: 0};
				}
				previousMonths[d.value.type].count++;
				previousMonths[d.value.type].days += monthDays;
				previousMonths[d.value.type].avgLOS += d.value.avgLOS;
				previousMonths[d.value.type].los += d.value.los;
			}else{
				if(!(d.value.type in currentMonth)){
					currentMonth[d.value.type] = {name: d.value.type, avgLOS: 0, avgPercent: 0, count: 0, days: 0, los: 0};
				}
				currentMonth[d.value.type].count++;
				currentMonth[d.value.type].days += monthDays;
				currentMonth[d.value.type].avgLOS += d.value.avgLOS;
				currentMonth[d.value.type].los += d.value.los;
			}

			if(!(monthFormat(d.key) in totalChangeForMonths)){
				totalChangeForMonths[monthFormat(d.key)] 					= {name: monthFormat(d.key), avgLOS: 0, count: 0, los: 0};
			}

			if(!(d.value.type in totalChangeForMonths[monthFormat(d.key)])){
				totalChangeForMonths[monthFormat(d.key)][d.value.type] 		= {avgLOS: 0, count: 0, los: 0};
			}
			totalChangeForMonths[monthFormat(d.key)].count++;
			totalChangeForMonths[monthFormat(d.key)].avgLOS += d.value.avgLOS;
			totalChangeForMonths[monthFormat(d.key)].los += d.value.los;
			totalChangeForMonths[monthFormat(d.key)][d.value.type].count++;
			totalChangeForMonths[monthFormat(d.key)][d.value.type].avgLOS += d.value.avgLOS;
			totalChangeForMonths[monthFormat(d.key)][d.value.type].los += d.value.los;

		});

		
		if(losType == 'los')
		{

			//total change for each month
			for(var month in totalChangeForMonths){
				totalChangeForMonths[month].count = (totalChangeForMonths[month].los / totalChangeForMonths[month].count) * getPaytypes().length;
			}
			mainChartPostRenderFunction = function(){setSimplePostRender(totalChangeForMonths, false, '', '', 'los');};

			for(var paytype in previousMonths){
				previousMonths[paytype].los = previousMonths[paytype].los;
				previousMonths[paytype].avgPercent = previousMonths[paytype].los / previousMonths[paytype].days;
			}
			for(var paytype in currentMonth){
				currentMonth[paytype].los = currentMonth[paytype].los;
				currentMonth[paytype].avgPercent = currentMonth[paytype].los / currentMonth[paytype].days;
			}

			//changes

			for(var paytype in previousMonths){
				var set = {name: paytype},
					firstMonth = Object.values(totalChangeForMonths)[0];

				if(paytype in currentMonth){
					set.change = true;
					set.changeType = (isTwoMonths ? 'decreased' : 'in the previous '+(monthCount-1)+' months had a downward trend');
					set.changeDays = currentMonth[paytype].los - firstMonth[paytype].los;

					if(set.changeDays > 0){
						set.changeType = (isTwoMonths ? 'increased' : 'in the previous '+(monthCount-1)+' months had a upward trend');
					}else if(set.changeDays == 0){
						set.changeType = 'same';
						set.changeDays = currentMonth[paytype].changeDays;
					}
					set.changePercent = ((set.changeDays/ firstMonth[paytype].los) * 100).toFixed(2);
					delete currentMonth[paytype];
				}else{
					set.change = false;
					set.previous = true;
					set.days = previousMonths[paytype].los;
					set.percent = (previousMonths[paytype].avgPercent * 100).toFixed(2);
				}
				infoListValues.push(set);
			}

			//total change in los


			var totalChangeSet = {name: 'All', change: true, changeDays: 0, changePercent: 0, count: 0, changeType: (isTwoMonths ? 'decreased' : 'in the previous '+(monthCount-1)+' months had a downward trend')};

			var current = 0,
				totalChangeClone = $.extend(true,{},totalChangeForMonths),
				lastMonth = Object.values(totalChangeClone)[Object.keys(totalChangeClone).length - 1];
			
			firstMonth = Object.values(totalChangeClone)[0];


			totalChangeSet.changeDays = lastMonth.los - firstMonth.los;
			totalChangeSet.changePercent = ((totalChangeSet.changeDays/ firstMonth.los) * 100).toFixed(2);
			if(totalChangeSet.changeDays > 0){
				totalChangeSet.changeType = (isTwoMonths ? ' increased' : 'in the previous '+(monthCount-1)+' months had a upward trend');
			}else if(totalChangeSet.changeDays == 0){
				totalChangeSet.changeType = 'same';
			}

			//paytypes in current month not in last month
			for(var paytype in currentMonth){
				var set = {
					name: paytype,
					change: false,
					previous: false,
					days: currentMonth[paytype].los,
					percent: (currentMonth[paytype].avgPercent * 100).toFixed(2),
				};
				infoListValues.push(set);
			}
			infoListValues.push(totalChangeSet);
			infoListValues.forEach(function(d){
				var li = '<li class="'+(d.name in colors ? '_'+colors[d.name].substr(1, (colors[d.name].length - 1)) : '')+'"><b>'+d.name+'</b> ';
				if(d.change){
					if(d.changeDays == 0 || isNaN(d.changeDays)) return;
					if(d.changePercent == 'Infinity') d.changePercent = 100;
					if(d.changeType != 'same'){
						li = li+d.changeType+(isTwoMonths ? ' by ' : ' of ');
					}else{
						li = li+'did not change and is ';
					}
					li = li+Math.abs(parseFloat(d.changeDays)).toFixed(2)+' days or '+Math.abs(parseFloat(d.changePercent))+'%';
				}else{
					if(d.days == 0) return;
					if(d.previous){
						li = li+(isWithinMonth ? ' decreased by ' : 'had an average of ')+Math.abs(parseFloat(d.days)).toFixed(2)+' days in the previous months';
					}else{
						li = li+(isWithinMonth ? ' increased by ' : 'is ')+Math.abs(parseFloat(d.days)).toFixed(2)+' days';
					}
				}
				li = li+'</li>';
				infoList.append(li);
			});
		}
		else
		{
			//total change for each month
			// for(var month in totalChangeForMonths){
			// 	totalChangeForMonths[month].avgLOS = (totalChangeForMonths[month].avgLOS / totalChangeForMonths[month].count) * getPaytypes().length;
			// }
			mainChartPostRenderFunction = function(){setSimplePostRender(totalChangeForMonths, false, '', '', 'avgLOS');};

			for(var paytype in previousMonths){
				previousMonths[paytype].avgLOS = previousMonths[paytype].avgLOS / previousMonths[paytype].count;
				previousMonths[paytype].avgPercent = previousMonths[paytype].avgLOS / previousMonths[paytype].days;
			}
			for(var paytype in currentMonth){
				currentMonth[paytype].avgLOS = currentMonth[paytype].avgLOS / currentMonth[paytype].count;
				currentMonth[paytype].avgPercent = currentMonth[paytype].avgLOS / currentMonth[paytype].days;
			}

			//changes
			for(var paytype in previousMonths){
				var set = {name: paytype};
				firstMonth = Object.values(totalChangeForMonths)[0];
				if(paytype in currentMonth){
					set.change = true;
					set.changeType = (isTwoMonths ? 'decreased' : 'in the previous '+(monthCount-1)+' months had a downward trend');
					set.changeDays = currentMonth[paytype].avgLOS - firstMonth[paytype].avgLOS;
					if(set.changeDays > 0){
						set.changeType = (isTwoMonths ? 'increased' : 'in the previous '+(monthCount-1)+' months had a upward trend');
					}else if(set.changeDays == 0){
						set.changeType = 'same';
						set.changeDays = currentMonth[paytype].changeDays;
					}
					set.changePercent = ((set.changeDays/ firstMonth[paytype].avgLOS) * 100).toFixed(2);
					delete currentMonth[paytype];
				}else{
					set.change = false;
					set.previous = true;
					set.days = previousMonths[paytype].avgLOS;
					set.percent = (previousMonths[paytype].avgPercent * 100).toFixed(2);
				}
				infoListValues.push(set);
			}
			//total change in los
			var totalChangeSet = {name: 'All', change: true, changeDays: 0, changePercent: 0, count: 0, changeType: (isTwoMonths ? 'decreased' : 'in the previous '+(monthCount-1)+' months had a downward trend')};

			var current = 0,
				totalChangeClone = $.extend(true,{},totalChangeForMonths);

			lastMonth = Object.values(totalChangeClone)[Object.keys(totalChangeClone).length - 1];
			firstMonth = Object.values(totalChangeClone)[0];


			totalChangeSet.changeDays = lastMonth.avgLOS - firstMonth.avgLOS;
			totalChangeSet.changePercent = ((totalChangeSet.changeDays/ firstMonth.avgLOS) * 100).toFixed(2);

			if(totalChangeSet.changeDays > 0){
				totalChangeSet.changeType = (isTwoMonths ? 'increased' : 'in the previous '+(monthCount-1)+' months had a upward trend');
			}else if(totalChangeSet.changeDays == 0){
				totalChangeSet.changeType = 'same';
			}

			//paytypes in current month not in last month
			for(var paytype in currentMonth){
				var set = {
					name: paytype,
					change: false,
					previous: false,
					days: currentMonth[paytype].avgLOS,
					percent: (currentMonth[paytype].avgPercent * 100).toFixed(2)
				};
				infoListValues.push(set);
			}
			infoListValues.push(totalChangeSet);
			infoListValues.forEach(function(d){
				var li = '<li class="'+(d.name in colors ? '_'+colors[d.name].substr(1, (colors[d.name].length - 1)) : '')+'"><b>'+d.name+'</b> ';
				if(d.change){
					if(d.changeDays == 0 || isNaN(d.changeDays)) return;
					if(d.changePercent == 'Infinity') d.changePercent = 100;
					if(d.changeType != 'same'){
						li = li+d.changeType+(isTwoMonths ? ' by ' : ' of ');
					}else{
						li = li+'did not change and is ';
					}
					li = li+Math.abs(parseFloat(d.changeDays)).toFixed(2)+' days or '+Math.abs(parseFloat(d.changePercent))+'%';
				}else{
					if(d.days == 0) return;
					if(d.previous){
						li = li+(isWithinMonth ? 'decreased by ' : 'had an average of ')+Math.abs(parseFloat(d.days)).toFixed(2)+' days in the previous months';
					}else{
						li = li+(isWithinMonth ? 'increased by ' : 'is ')+Math.abs(parseFloat(d.days)).toFixed(2)+' days';
					}
				}
				li = li+'</li>';
				infoList.append(li);
			});

			$('#graphSubtitle').text('AVERAGE LENGTH OF STAY BY MONTH');
		}
	}else if(mainGraphFilter == 'physician'){
		infoList.hide();
		table.show();
		var colors = getPieColors(physicianChart).values;
		var currentFilters = physicianChart.filters();
		var allPhysicians = physicianChart.group().all();
		var mainChartAll = mainChart.group().all();
		var payorFilters = financialChart.filters();
		allPhysicians.forEach(function(d){
			var set = {};
			set['name'] = d.key;
			set['payors'] = {};
			for(var i = 0; i < mainChartAll.length; i++){
				if(mainChartAll[i].key == d.key){
					var residents = removeRepeatNames(mainChartAll[i].value.names);
					residents.forEach(function(r){
						if(!(r.paytype in set['payors']) && (r.paytype == 'Medicare' || r.paytype == 'Medicaid' || r.paytype == 'Private' || r.paytype == 'HMO')){
							set['payors'][r.paytype] = {type: r.paytype, count: 0};
						}
						if((r.paytype == 'Medicare' || r.paytype == 'Medicaid' || r.paytype == 'Private' || r.paytype == 'HMO')){
							set['payors'][r.paytype].count++;
						}else{
							if(!('Others' in set['payors'])){
								set['payors']['Others'] = {type: 'Others', count: 0};
							}
							set['payors'].Others.count++;
						}
					});
					break;
				}
			}
			//add in missing paytypes
			for(var i = 0; i < paytypes.length; i++){
				if(!(paytypes[i].key in set['payors']) && (paytypes[i].key == 'Medicare' || paytypes[i].key == 'Medicaid' || paytypes[i].key == 'Private' || paytypes[i].key == 'HMO')){
					set['payors'][paytypes[i].key] = {type: paytypes[i].key, count: 0};
				}else if(!('Others' in set['payors'])){
					set['payors']['Others'] = {type: 'Others', count: 0};
				}
			}
			if(currentFilters.length != 0){
				if(currentFilters.indexOf(set.name) !== -1){
					infoListValues.push(set);
				}
			}else{
				infoListValues.push(set);
			}
		});
		tableHead.append('<th width="30%">ADMISSIONS</th>');
		var th = [];
		for(var i = 0; i < paytypes.length; i++){
			if(paytypes[i].key == 'Medicare' || paytypes[i].key == 'Medicaid' || paytypes[i].key == 'Private' || paytypes[i].key == 'HMO'){
				th.push(paytypes[i].key);
			}else{
				if(th.indexOf('Others') == -1){
					th.push('Others');
				}
			}
		}
		th.sort(function(a, b){
				var textA = a.toUpperCase();
			    var textB = b.toUpperCase();
			    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
			});
		var widthForTH = 70 / th.length;
		th.forEach(function(d){
			tableHead.append('<th width="'+widthForTH+'%">'+d+'</th>');
		});
		infoListValues.forEach(function(d){
			if(d.name == ''){
				return;
			}
			subtitle += d.name+', ';
			var html = '<tr class="'+(d.name in colors ? '_'+colors[d.name].substr(1, (colors[d.name].length - 1))+' hover' : '')+'"><td><span title="'+d.name+'">'+d.name+'</span></td>';
			d.payors = $.map(d.payors, function(value, index){
				return value;
			}).sort(function(a, b){
				var textA = a.type.toUpperCase();
			    var textB = b.type.toUpperCase();
			    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
			});
			d.payors.forEach(function(p){
				if(p.type == 'Others'){
					if(th.indexOf('Others') == -1){
						return;
					}
				}
				html += '<td>'+(p.count != 0 ? p.count : '&nbsp;')+'</td>';
			});
			html += '</tr>';
			tableBody.append(html);
		});
		if(currentFilters.length != 0){
			$('#graphSubtitle').text(subtitle.substr(0, (subtitle.length - 2))+ ' ADMISSIONS BY '+(isWithinMonth ? 'DAY' : 'MONTH'));
		}else{
			$('#graphSubtitle').text('TOTAL ADMISSIONS BY PHYSICIAN');
		}
	}else if(mainGraphFilter == 'origin'){
		infoList.hide();
		table.show();
		var colors = getPieColors(originChart).values;
		var currentFilters = originChart.filters();
		var allOrigins = originChart.group().all();
		var mainChartAll = mainChart.group().all();
		var payorFilters = financialChart.filters();
		allOrigins.forEach(function(d){
			var set = {};
			set['name'] = d.key;
			set['payors'] = {};
			for(var i = 0; i < mainChartAll.length; i++){
				if(mainChartAll[i].key == d.key){
					var residents = removeRepeatNames(mainChartAll[i].value.names);
					residents.forEach(function(r){
						if(!(r.paytype in set['payors']) && (r.paytype == 'Medicare' || r.paytype == 'Medicaid' || r.paytype == 'Private' || r.paytype == 'HMO')){
							set['payors'][r.paytype] = {type: r.paytype, count: 0};
						}
						if((r.paytype == 'Medicare' || r.paytype == 'Medicaid' || r.paytype == 'Private' || r.paytype == 'HMO')){
							set['payors'][r.paytype].count++;
						}else{
							if(!('Others' in set['payors'])){
								set['payors']['Others'] = {type: 'Others', count: 0};
							}
							set['payors'].Others.count++;
						}
					});
					break;
				}
			}
			//add in missing paytypes
			for(var i = 0; i < paytypes.length; i++){
				if(!(paytypes[i].key in set['payors']) && (paytypes[i].key == 'Medicare' || paytypes[i].key == 'Medicaid' || paytypes[i].key == 'Private' || paytypes[i].key == 'HMO')){
					set['payors'][paytypes[i].key] = {type: paytypes[i].key, count: 0};
				}else if(!('Others' in set['payors'])){
					set['payors']['Others'] = {type: 'Others', count: 0};
				}
			}
			if(currentFilters.length != 0){
				if(currentFilters.indexOf(set.name) !== -1){
					infoListValues.push(set);
				}
			}else{
				infoListValues.push(set);
			}
		});
		tableHead.append('<th width="30%">ADMISSIONS</th>');
		var th = [];
		for(var i = 0; i < paytypes.length; i++){
			if(paytypes[i].key == 'Medicare' || paytypes[i].key == 'Medicaid' || paytypes[i].key == 'Private' || paytypes[i].key == 'HMO'){
				th.push(paytypes[i].key);
			}else{
				if(th.indexOf('Others') == -1){
					th.push('Others');
				}
			}
		}
		th.sort(function(a, b){
				var textA = a.toUpperCase();
			    var textB = b.toUpperCase();
			    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
			});
		var widthForTH = 70 / th.length;
		th.forEach(function(d){
			tableHead.append('<th width="'+widthForTH+'%">'+d+'</th>');
		});
		infoListValues.forEach(function(d){
			if(d.name == ''){
				return;
			}
			subtitle += d.name+', ';
			var html = '<tr class="'+(d.name in colors ? '_'+colors[d.name].substr(1, (colors[d.name].length - 1))+' hover' : '')+'"><td><span title="'+d.name+'">'+d.name+'</span></td>';
			d.payors = $.map(d.payors, function(value, index){
				return value;
			}).sort(function(a, b){
				var textA = a.type.toUpperCase();
			    var textB = b.type.toUpperCase();
			    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
			});
			d.payors.forEach(function(p){
				if(p.type == 'Others'){
					if(th.indexOf('Others') == -1){
						return;
					}
				}
				html += '<td>'+p.count+'</td>';
			});
			html += '</tr>';
			tableBody.append(html);
		});
		if(currentFilters.length != 0){
			$('#graphSubtitle').text(subtitle.substr(0, (subtitle.length - 2))+ ' ADMISSIONS BY '+(isWithinMonth ? 'DAY' : 'MONTH'));
		}else{
			$('#graphSubtitle').text('TOTAL ACUTE HOSPITAL ADMISSIONS BY '+(isWithinMonth ? 'DAY' : 'MONTH'));
		}
	}else if(mainGraphFilter == 'paytype'){
		var colors = getPieColors(financialChart).values;
		var currentFilters = financialChart.filters();
		currentFilters = currentFilters.concat(dischargesChart.filters()).concat(admissionsChart.filters());
		if(censusChart != undefined){
			currentFilters.concat(censusChart.filters());
		}
		var total = 0;
		paytypes.forEach(function(d){
			var set = {}
			set['name'] = d.key;
			set['total'] = d.value;
			if(currentFilters.length != 0){
				if(currentFilters.indexOf(set.name) !== -1){
					infoListValues.push(set);
					total += set.total;
				}
			}else{
				infoListValues.push(set);
				total += set.total;
			}
		});
		infoListValues.forEach(function(d){
			if(d.total == 0){
				return;
			}
			subtitle += d.name+', ';
			infoList.append('<li class="'+(d.name in colors ? '_'+colors[d.name].substr(1, (colors[d.name].length - 1)) : '')+'"><b>'+d.name+'</b> admissions: <b>'+d.total+'</b> or <b>'+((d.total / total) * 100).toFixed(2)+'%<b></li>');
		});
		if(currentFilters.length != 0){
			$('#graphSubtitle').text(subtitle.substr(0, (subtitle.length - 2))+ ' ADMISSIONS BY '+(isWithinMonth ? 'DAY' : 'MONTH'));
		}else{
			$('#graphSubtitle').text('TOTAL PAYTYPE ADMISSIONS BY '+(isWithinMonth ? 'DAY' : 'MONTH'));
		}
	}else if(mainGraphFilter == 'census'){
		var monthCount = monthDiff($('#from').datepicker('getDate'), $('#to').datepicker('getDate'));
		var isTwoMonths = (monthCount == 2 ? true : false);
		var colors = getPieColors(censusChart).values;
		var mainChartAll = [];
		if(mainChart.allGroups == undefined){
			var paytypes = getPaytypes();
			for(var i = 0; i < paytypes.length; i++){
				var fakeDimension = ndx.dimension(function(d){
					return d3.time.month(d.admit_dt);
				});
				var fakeGroup = fakeDimension.group().reduce(
					function(p,v){
						var sorted = Object.keys(v.financial_change).sort(function(a,b){return a - b});
						if(v.financial_change[sorted[0]] == paytypes[i]){
							p.count++;
							p.type = paytypes[i];
							p.adc = (p.count / bedCount) * 100;
							var monthYear = new Date(v.admit_dt);
							p.adcAverage = p.adc / daysInMonth((monthYear.getMonth() + 1), monthYear.getFullYear());
						}
						return p;
					},
					function(p,v){
						var sorted = Object.keys(v.financial_change).sort(function(a,b){return a - b});
						if(v.financial_change[sorted[0]] == paytypes[i]){
							p.count--;
							p.adc = (p.count / bedCount) * 100;
							var monthYear = new Date(v.admit_dt);
							p.adcAverage = p.adc / daysInMonth((monthYear.getMonth() + 1), monthYear.getFullYear());
						}
						return p;
					},
					function(){
						return {
							count: 0,
							type: '',
							adc: 0,
							adcAverage: 0
						};
					}
				);
				fakeGroup.all().forEach(function(d){
					mainChartAll.push(d);
				});
				fakeGroup.dispose();
			};
		}else{
			mainChart.allGroups().forEach(function(d){
				d.all().forEach(function(a){
					mainChartAll.push(a);
				})
			});
		}
		var currentMonth = {};
		var previousMonths = {};
		var totalChangeForMonths = {};
		mainChartAll.forEach(function(d){
			if(d.value.type == undefined || d.value.type == "") return;
			var firstDayOfMonth = new Date(d.key);
			var lastDayOfMonth = new Date(firstDayOfMonth.getFullYear(), firstDayOfMonth.getMonth() + 1, 0);
			firstDayOfMonth.setDate(firstDayOfMonth.getDate()-1); //fixes first day so we include it
			var monthDays = Math.round(Math.abs((lastDayOfMonth.getTime() - firstDayOfMonth.getTime())/(oneDay)));

			if(monthFormat(d.key) != monthFormat(to)){
				if(!(d.value.type in previousMonths)){
					previousMonths[d.value.type] = {name: d.value.type, avgADC: 0, avgPercent: 0, count: 0, days: 0};
				}
				previousMonths[d.value.type].count++;
				previousMonths[d.value.type].days += monthDays;
				previousMonths[d.value.type].avgADC += d.value.adc;
				if(graphType == 'Pie' || graphType == 'Doughnut'){
					previousMonths[d.value.type].avgPercent = d.value.adcAverage;
				}else{
					previousMonths[d.value.type].avgPercent += d.value.adcAverage;
				}
			}else{
				if(!(d.value.type in currentMonth)){
					currentMonth[d.value.type] = {name: d.value.type, avgADC: 0, avgPercent: 0, count: 0, days: 0};
				}
				currentMonth[d.value.type].count++;
				currentMonth[d.value.type].days += monthDays;
				currentMonth[d.value.type].avgADC += d.value.adc;
				if(graphType == 'Pie' || graphType == 'Doughnut'){
					currentMonth[d.value.type].avgPercent = d.value.adcAverage;
				}else{
					currentMonth[d.value.type].avgPercent += d.value.adcAverage;
				}
			}

			if(!(monthFormat(d.key) in totalChangeForMonths)){
				totalChangeForMonths[monthFormat(d.key)] = {name: monthFormat(d.key), avgADC: 0, count: 0};
			}
			totalChangeForMonths[monthFormat(d.key)].count++;
			totalChangeForMonths[monthFormat(d.key)].avgADC += d.value.adc / monthDays;
		});

		if(!isWithinMonth && (graphType != 'Pie' && graphType != 'Doughnut')){
			mainChartPostRenderFunction = function(){accumlativePostRender(totalChangeForMonths, false, '', '% ADC', 'avgADC');};
		}

		for(var paytype in previousMonths){
			previousMonths[paytype].avgADC = previousMonths[paytype].avgADC / previousMonths[paytype].count;
			if(graphType != 'Pie' && graphType != 'Doughnut' && !isWithinMonth){
				previousMonths[paytype].avgPercent = previousMonths[paytype].avgADC / previousMonths[paytype].days;
			}
		}
		
		for(var paytype in currentMonth){
			if(!isWithinMonth){
				currentMonth[paytype].avgADC = currentMonth[paytype].avgADC / currentMonth[paytype].count;
			}
			if(graphType != 'Pie' && graphType != 'Doughnut' && !isWithinMonth){
				currentMonth[paytype].avgPercent = currentMonth[paytype].avgADC / currentMonth[paytype].count;
			}
		}
		

		//changes
		if(!isWithinMonth){
			for(var paytype in previousMonths){
				var set = {name: paytype};
				if(paytype in currentMonth){
					set.change = true;
					set.changeType = (isTwoMonths ? 'decreased' : 'in the previous '+(monthCount-1)+' months had a downward trend');
					set.changeADC = currentMonth[paytype].avgADC - previousMonths[paytype].avgADC;
					set.changePercent = ((currentMonth[paytype].avgADC - previousMonths[paytype].avgADC) / previousMonths[paytype].avgADC).toFixed(2);
					if(set.changeADC > 0){
						set.changeType = (isTwoMonths ? 'increased' : 'in the previous '+(monthCount-1)+' months had a upward trend');
					}else if(set.changeADC == 0){
						set.changeType = 'same';
						set.changeADC = currentMonth[paytype].avgADC;
						set.changePercent = 0;
					}
					delete currentMonth[paytype];
				}else{
					set.change = false;
					set.previous = true;
					set.adc = previousMonths[paytype].avgADC;
					set.percent = (previousMonths[paytype].avgADC * 100).toFixed(2);
				}
				infoListValues.push(set);
			}
			//total change in adc
			var totalChangeSet = {name: 'All', change: true, changeADC: 0, changePercent: 0, count: 0, changeType: (isTwoMonths ? 'decreased' : 'in the previous '+(monthCount-1)+' months had a downward trend')};
			var allPrevious = 0,
				prevousCount = 0,
				current = 0,
				totalChangeClone = $.extend(true,{},totalChangeForMonths);
			for(var month in totalChangeClone){
				if(month != monthFormat(to)){
					prevousCount++;
					allPrevious += totalChangeClone[month].avgADC;
				}else{
					current = totalChangeClone[month].avgADC;
				}
			}
			allPrevious = allPrevious / prevousCount;

			totalChangeSet.changeADC = current - allPrevious;
			totalChangeSet.changePercent = ((current - allPrevious) / allPrevious);
			if(totalChangeSet.changeADC > 0){
				totalChangeSet.changeType = (isTwoMonths ? 'increased' : 'in the previous '+(monthCount-1)+' months had a upward trend');
			}else if(totalChangeSet.changeADC == 0){
				totalChangeSet.changeType = 'same';
			}
			//paytypes in current month not in last month
			for(var paytype in currentMonth){
				var set = {
					name: paytype,
					change: false,
					previous: false,
					adc: currentMonth[paytype].avgADC,
					percent: (currentMonth[paytype].avgPercent * 100).toFixed(2)
				};
				infoListValues.push(set);
			}
			infoListValues.push(totalChangeSet);
		}else{
			var per = 0;
			for(var paytype in currentMonth){
				var set = {
					name: paytype,
					adc: currentMonth[paytype].avgADC.toFixed(2),
					percent: currentMonth[paytype].avgPercent.toFixed(2)
				};
				infoListValues.push(set);
			}
		}
		infoListValues.forEach(function(d){
			if(isWithinMonth){
				if(d.adc == 0 || d.percent == 0) return;
			}else{
				if(d.changeADC == 0 || d.changePercent == 0) return;
			}
			var li = '<li class="'+(d.name in colors ? '_'+colors[d.name].substr(1, (colors[d.name].length - 1)) : '')+'"><b>'+d.name+'</b> ';
			if(!isWithinMonth){
				if(d.change){
					if(isNaN(d.changeADC)) return;
					if(d.changePercent == 'Infinity') d.changePercent = 1;
					if(d.changeType != 'same'){
						li = li+d.changeType+(isTwoMonths ? ' by ' : ' of ');
					}else{
						li = li+'did not change and is ';
					}
					li = li+Math.abs(parseFloat(d.changeADC)).toFixed(2)+' patient days or '+(Math.abs(parseFloat(d.changePercent)) * 100).toFixed(2)+'%';
				}else{
					if(d.adc == 0) return;
					if(d.previous){
						li = li+(isWithinMonth ? 'decreased by ' : 'is ')+Math.abs(parseFloat(d.adc)).toFixed(2)+' or 100%';
					}else{
						li = li+(isWithinMonth ? 'increased by' : 'is ')+Math.abs(parseFloat(d.adc)).toFixed(2);
					}
				}
			}else{
				li = li + 'was ' + d.adc + ' patient days or ' + d.percent + '% of your ADC';
			}
			li = li+'</li>';
			infoList.append(li);
		});

		$('#graphSubtitle').text('TOTAL AVERAGE DAILY CENSUS BY MONTH');
	}else if(mainGraphFilter == 'rawreadmission'){
		var colors = getPieColors(rawreadmissionChart).values;
		var allMonths = rawreadmissionChart.group().all();
		var average = 0;
		allMonths.forEach(function(d){
			infoListValues.push({name: d.key, value: (d.value.readmitPercent * 100).toFixed(2)});
			average += d.value.readmitPercent;
		});
		average = ((average / allMonths.length) * 100).toFixed(2)
		infoListValues.forEach(function(d){
			infoList.append('<li class="'+(d.name in colors ? '_'+colors[d.name].substr(1, (colors[d.name].length - 1)) : '')+'">'+monthFormat(d.name)+' readmission rate: <b>'+d.value+'</b>%</li>');
		});
		infoList.append('<li>Combined Readmission rate: <b>'+average+'</b>%</li>');
		$('#graphSubtitle').text('TOTAL READMISSION RATE BY MONTH');
		mainChartPostRenderFunction = function(){setSimplePostRender('readmitPercent', true, '', '%');};
	}else if(mainGraphFilter == 'riskadjusted'){
		var colors = getPieColors(riskadjustedChart).values;
		var allMonths = riskadjustedChart.group().all();
		var average = 0;
		var months = {};
		allMonths.forEach(function(d){
			infoListValues.push({name: d.key, value: (d.value.riskAdjustPercent * 100).toFixed(2)});
			average += d.value.riskAdjustPercent;
		});
		average = ((average / allMonths.length) * 100).toFixed(2)
		infoListValues.forEach(function(d){
			infoList.append('<li class="'+(d.name in colors ? '_'+colors[d.name].substr(1, (colors[d.name].length - 1)) : '')+'">'+monthFormat(d.name)+' readmission rate: <b>'+d.value+'</b>%</li>');
		});
		$('#percents').append('<p id="meaning">The risk adjusted readmission rate is based on your residents risk for readmission. It takes into account national statistics of other skilled nursing facilities, and adjusts your readmission rate with the average skilled nursing home readmission rate.</p>')
		infoList.append('<li>Combined Risk adjusted readmission rate: <b>'+average+'</b>%</li>');
		$('#graphSubtitle').text('TOTAL ADJUSTED READMISSION RATE BY MONTH');
		mainChartPostRenderFunction = function(){setSimplePostRender('riskAdjustPercent', true, '', '%');};
	}else if(mainGraphFilter == 'deficiencies'){
		infoList.hide();
		table.show().addClass('indicators');
		var colors = getPieColors(deficiencyChart).values;
		var currentFilters = deficiencyChart.filters();
		var allDeficiencies = deficiencyChart.group().all();
		if(mainChart.allGroups == undefined){
			var mainChartAll = mainChart.group().all();
		}else{
			var mainChartAll = mainChart.allGroups();
			mainChartAll = mainChartAll.map(function(d){
				return d.all();
			});
			mainChartAll = [].concat.apply([], mainChartAll);
		}
		var categoryFilters = categoryChart.filters();
		var allCategories = $.map(categoryChart.group().all(), function(value, index){
								return value.key;
							});
		// allCategories.forEach(function(d){
		// 	var set = {};
		// 	set['name'] = d;
		// 	set['deficiencies'] = {};
		// 	for(var i = 0; i < mainChartAll.length; i++){
		// 		if(graphType == 'Pie' || graphType == 'Doughnut'){
		// 			if(d in mainChartAll[i].value.category){
		// 				if(currentFilters.length != 0){
		// 					if(currentFilters.indexOf(mainChartAll[i].key) === -1){
		// 						continue;
		// 					}
		// 				}
		// 				var deficiency = mainChartAll[i].key;
		// 				if(!(deficiency in set['deficiencies'])){
		// 					set['deficiencies'][deficiency] = {type: deficiency, count: 0};
		// 				}
		// 				set['deficiencies'][deficiency].count = mainChartAll[i].value.category[d].length;
		// 			}
		// 		}else{
		// 			if(mainChartAll[i].value.category == d){
		// 				if(currentFilters.length != 0){
		// 					if(currentFilters.indexOf(mainChartAll[i].key) === -1){
		// 						continue;
		// 					}
		// 				}
		// 				var deficiency = mainChartAll[i].key;
		// 				if(!(deficiency in set['deficiencies'])){
		// 					set['deficiencies'][deficiency] = {type: deficiency, count: 0};
		// 				}
		// 				set['deficiencies'][deficiency].count = mainChartAll[i].value.total;
		// 			}
		// 		}
		// 	}

		// 	console.log(set);



		// 	add in missing paytypes
			
		// 	for(var i = 0; i < allDeficiencies.length; i++){
		// 		if(!(allDeficiencies[i].key in set['deficiencies'])){
		// 			set['deficiencies'][allDeficiencies[i].key] = {type: allDeficiencies[i].key, count: 0};
		// 		}
		// 		console.log(allDeficiencies);
		// 	}
		// 	if(categoryFilters.length != 0){
		// 		if(categoryFilters.indexOf(d) !== -1){
		// 			infoListValues.push(set);
		// 		}
		// 	}else{
		// 		infoListValues.push(set);
		// 	}

		// });

		var set = {};
		set['deficiencies'] = {};

		indicatorData.forEach(function(d){

			if(!set['deficiencies'][d.department]){
				set['deficiencies'][d.department] = [];
			}
			if(currentFilters.length != 0){
				if(currentFilters.indexOf(d.letter) === -1){
					return;
				}
			}
			var deficiency = d.letter;
			if(!set['deficiencies'][d.department][deficiency]){
				set['deficiencies'][d.department][deficiency] = {type: deficiency, count: 0};
			}
			set['deficiencies'][d.department][deficiency].count++;

		});

		$.each(set['deficiencies'], function(i, v){
			for(var j = 0; j < allDeficiencies.length; j++){
				var key = allDeficiencies[j].key;

				if(!v[key]) v[key] = {type: key, count: 0};
			}
		});


		infoListValues = set['deficiencies'];
		tableHead.append('<th width="25%">CATEGORY</th>');
		var th = [];
		for(var i = 0; i < allDeficiencies.length; i++){
			th.push(allDeficiencies[i].key);
		}

		th.sort(function(a, b){
				var textA = a.toUpperCase();
			    var textB = b.toUpperCase();
			    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
			});
		var widthForTH = 75 / th.length;
		th.forEach(function(d){
			tableHead.append('<th width="'+widthForTH+'%" class="'+(d in colors ? '_'+colors[d].substr(1, (colors[d].length - 1))+' hover' : '')+'">'+d+'</th>');
		});


		$.each(infoListValues, function(index, value){
			subtitle += index+', ';
			var html = '<tr><td><span title="'+index+'">'+index+'</span></td>';
			for(var i = 0; i < allDeficiencies.length; i++){
				html += '<td class="'+(value[allDeficiencies[i].key].type in colors ? '_'+colors[value[allDeficiencies[i].key].type].substr(1, (colors[value[allDeficiencies[i].key].type].length - 1))+' hover' : '')+'">'+(value[allDeficiencies[i].key].count != 0 ? value[allDeficiencies[i].key].count : '&nbsp;')+'</td>';
			}
			html += '</tr>';
			tableBody.append(html);
		});
		if(currentFilters.length != 0){
			$('#graphSubtitle').text(subtitle.substr(0, (subtitle.length - 2))+ ' DEFICIENCIES OUT OF '+totalIndicators+' INDICATORS');
		}else{
			$('#graphSubtitle').text('TOTAL DEFICIENCIES OUT OF '+totalIndicators+' INDICATORS');
		}
	}else if(mainGraphFilter == 'surveys'){
		var monthCount = monthDiff($('#from').datepicker('getDate'), $('#to').datepicker('getDate'));
		var isTwoMonths = (monthCount == 2 ? true : false);
		var colors = getPieColors(surveyChart).values;
		var mainChartAll = [];
		var currentFilters = surveyChart.filters().map(function(d){
			return parseInt(d);
		});
		if(currentFilters == undefined){
			currentFilters = [];
		}
		if(mainChart.allGroups == undefined){
			var answersNumbers = surveyChart.group().all().map(function(d){
				return d.key;
			});
			for(var i = 0; i < answersNumbers.length; i++){
				var fakeGroup = mainDimension.group().reduce(
					function(p,v){
						for(var answer in v.answers){
							if(v.answers[answer] == parseInt(answersNumbers[i])){
								p.count++;
								p.total++;
								p.type = answersNumbers[i];
								p.answer = p.count * parseInt(p.type);
								p.month = d3.time.month(v.assignedMonthYear);
							}
						}
						return p;
					},
					function(p,v){
						for(var answer in v.answers){
							if(v.answers[answer] == parseInt(answersNumbers[i])){
								p.total--;
								p.count--;
								p.answer = p.count * parseInt(p.type);
							}
						}
						return p;
					},
					function(){
						return {
							count: 0,
							type: '',
							answer: 0,
							month: '',
							total: 0
						};
					}
				);
				fakeGroup.all().forEach(function(d){
					mainChartAll.push(d);
				});
				fakeGroup.dispose();
			};
		}else{
			mainChart.allGroups().forEach(function(d){
				d.all().forEach(function(a){
					mainChartAll.push(a);
				})
			});
		}
		var currentMonth = {};
		var previousMonths = {};
		var totalChangeForMonths = {};

		var adjustedTotals = {previous: 0};
		mainChartAll.forEach(function(d){
			if(d.value.type == undefined || d.value.type == "") return;

			if(!(monthFormat(d.value.month) in adjustedTotals)){
				adjustedTotals[monthFormat(d.value.month)] = 0;
			}

			adjustedTotals[monthFormat(d.value.month)] += d.value.names['all'].length;

			if(!(monthFormat(d.value.month) in totalChangeForMonths)){
				totalChangeForMonths[monthFormat(d.value.month)] = {name: monthFormat(d.value.month), avg: 0, totals: []};
			}
			totalChangeForMonths[monthFormat(d.value.month)].totals.push({total: d.value.names['all'].length, weighted: (d.value.names['all'].length * parseInt(d.value.type)), type: parseInt(d.value.type)});

			if(currentFilters.length != 0){
				if(currentFilters.indexOf(d.value.type) == -1){
					return;
				}
			}


			if(monthFormat(d.value.month) != monthFormat(to)){
				if(!(d.value.type in previousMonths)){
					previousMonths[d.value.type] = {name: d.value.type, average: 0, adjusted: 0, counts: []};
				}
				previousMonths[d.value.type].counts.push(d.value.total);
			}else{
				if(!(d.value.type in currentMonth)){
					currentMonth[d.value.type] = {name: d.value.type, average: 0, adjusted: 0, counts: []};
				}
				currentMonth[d.value.type].counts.push(d.value.total);
			}

			
		});
		for(var month in totalChangeForMonths){
			var totals = 0,
				weighted = 0;
			totalChangeForMonths[month].totals.forEach(function(d){
				totals += d.total;
				weighted += d.weighted;
			});

			var avg = (weighted / totals).toFixed(2);
			totalChangeForMonths[month].avg = avg;
		}

		if(graphType != 'Pie' && graphType != 'Doughnut'){
			mainChartPostRenderFunction = function(){createScales(totalChangeForMonths);};
		}

		for(var month in adjustedTotals){
			if(month != monthFormat(to)){
				adjustedTotals['previous'] += adjustedTotals[month];
			}else{
				adjustedTotals['current'] = adjustedTotals[month];
			}
			if(month != 'previous' && month != 'current'){
				delete adjustedTotals[month];
			}
		}

		for(var answer in previousMonths){
			previousMonths[answer].average = previousMonths[answer].counts.average();

		}
		for(var answer in currentMonth){
			currentMonth[answer].average = currentMonth[answer].counts.average();
		}

		var options = {
			changeType: {
				decreased: (isTwoMonths ? 'decreased' : 'in the previous '+(monthCount-1)+' months had a downward trend'),
				increased: (isTwoMonths ? 'increased' : 'in the previous '+(monthCount-1)+' months had a upward trend')
			}
		};
		infoListValues = arrayChanges(previousMonths, currentMonth, options, adjustedTotals);

		var fromMonth = $('#from').datepicker('getDate'),
			toMonth = $('#to').datepicker('getDate');
		infoListValues.forEach(function(d){
			if(isNaN(d.changePercent)){
				return;
			}
			var li = '<li class="'+(d.name in colors ? '_'+colors[d.name].substr(1, (colors[d.name].length - 1)) : '')+'"><b>'+answerValues[d.name]+'</b> ';
			if(d.didChange){
				if(isNaN(d.change)) return;
				if(d.changePercent == 'Infinity') d.changePercent = 100;
				if(d.adjustedPercent != 0){
					li = li+(d.adjustedPercent < 0 ? 'decreased by ' : 'increased by ')+Math.abs((parseFloat(d.adjustedPercent) * 100).toFixed(2))+'% weighted from '+getMonthName(fromMonth.getMonth())+' to '+getMonthName(toMonth.getMonth())+'.';
				}else{
					li = li+'did not change and is 0.00%.';
				}
				li += ' Unweighted responses '
				
				if(d.changeType == 'same'){
					li += 'did not change and are ';
				}else{
					li += d.changeType+' by ';
				}
				li += Math.abs(parseFloat(d.change).toFixed(2))+' or '+Math.abs(parseFloat(d.changePercent)).toFixed(2)+'%.';
			}else{
				if(d.previous){
					li = li+'decreased by '+Math.abs(parseFloat(d.change).toFixed(2))+' or 100%';
				}else{
					li = li+(isWithinMonth ? 'increased by ' : 'is ')+Math.abs(parseFloat(d.change).toFixed(2))+' or '+Math.abs(parseFloat(d.changePercent)).toFixed(2)+'%';
				}
			}
			li = li+'</li>';
			infoList.append(li);
		});

		$('#percents').append('<p id="meaning">Weighted: Takes into account the number of residents responding.<br>Un-Weighted: Does not take into account the number of residents responding.</p>');

		$('#graphSubtitle').text('PERCENTAGE OF CHANGE BY MONTH');
	}else if(mainGraphFilter == 'qis'){
		var monthCount = monthDiff($('#from').datepicker('getDate'), $('#to').datepicker('getDate'));
		var isTwoMonths = (monthCount == 2 ? true : false);
		var colors = getPieColors(qisChart).values;
		var mainChartAll = [];
		if(mainChart.allGroups == undefined){
			var paytypes = qisChart.group().all().map(function(d){
				return d.key;
			});
			for(var i = 0; i < paytypes.length; i++){
				var fakeGroup = mainDimension.group().reduce(
					function(p,v){
						for(var answer in v.answers){
							if(v.answers[answer] == parseInt(paytypes[i])){
								p.count++;
								p.total++;
								p.type = paytypes[i];
								p.answer = p.count * parseInt(p.type);
								p.month = d3.time.month(v.assignedMonthYear);
							}
						}
						return p;
					},
					function(p,v){
						for(var answer in v.answers){
							if(v.answers[answer] == parseInt(paytypes[i])){
								p.count--;
								p.total--;
								p.answer = p.count * parseInt(p.type);
							}
						}
						return p;
					},
					function(){
						return {
							count: 0,
							type: '',
							answer: 0,
							month: '',
							total: 0
						};
					}
				);
				fakeGroup.all().forEach(function(d){
					mainChartAll.push(d);
				});
				fakeGroup.dispose();
			};
		}else{
			mainChart.allGroups().forEach(function(d){
				d.all().forEach(function(a){
					mainChartAll.push(a);
				})
			});
		}
		var currentMonth = {};
		var previousMonths = {};
		var totalChangeForMonths = {};

		var adjustedTotals = {previous: 0};
		mainChartAll.forEach(function(d){
			if(d.value.type == undefined || d.value.type == "") return;

			if(!(monthFormat(d.value.month) in adjustedTotals)){
				adjustedTotals[monthFormat(d.value.month)] = 0;
			}

			adjustedTotals[monthFormat(d.value.month)] += d.value.names['all'].length;

			if(monthFormat(d.value.month) != monthFormat(to)){
				if(!(d.value.type in previousMonths)){
					previousMonths[d.value.type] = {name: d.value.type, average: 0, counts: []};
				}
				previousMonths[d.value.type].counts.push(d.value.total);
			}else{
				if(!(d.value.type in currentMonth)){
					currentMonth[d.value.type] = {name: d.value.type, average: 0, counts: []};
				}
				currentMonth[d.value.type].counts.push(d.value.total);
			}

			if(!(monthFormat(d.value.month) in totalChangeForMonths)){
				totalChangeForMonths[monthFormat(d.value.month)] = {name: monthFormat(d.value.month), avg: 0, totals: []};
			}
			totalChangeForMonths[monthFormat(d.value.month)].totals.push({total: (d.value.names['all'].length * parseInt(d.value.type)), weighted: (d.value.names['all'].length * parseInt(d.value.type)) * parseInt(d.value.type)});

		});
		for(var month in totalChangeForMonths){
			var totals = 0,
				weighted = 0;
			totalChangeForMonths[month].totals.forEach(function(d){
				totals += d.total;
				weighted += d.weighted;
			});
			totalChangeForMonths[month].avg = weighted / totals;
		}

		for(var month in adjustedTotals){
			if(month != monthFormat(to)){
				adjustedTotals['previous'] += adjustedTotals[month];
			}else{
				adjustedTotals['current'] = adjustedTotals[month];
			}
			if(month != 'previous' && month != 'current'){
				delete adjustedTotals[month];
			}
		}

		for(var answer in previousMonths){
			previousMonths[answer].average = previousMonths[answer].counts.average();
		}
		for(var answer in currentMonth){
			currentMonth[answer].average = currentMonth[answer].counts.average();
		}

		var options = {
			changeType: {
				decreased: (isTwoMonths ? 'decreased' : 'in the previous '+(monthCount-1)+' months had a downward trend'),
				increased: (isTwoMonths ? 'increased' : 'in the previous '+(monthCount-1)+' months had a upward trend')
			}
		};
		infoListValues = arrayChanges(previousMonths, currentMonth, options, adjustedTotals);
		var fromMonth = $('#from').datepicker('getDate'),
			toMonth = $('#to').datepicker('getDate');
		infoListValues.forEach(function(d){
			if(isNaN(d.changePercent)){
				return;
			}
			var li = '<li class="'+(d.name in colors ? '_'+colors[d.name].substr(1, (colors[d.name].length - 1)) : '')+'"><b>'+(d.name == 1 ? 'YES' : 'NO')+'</b> ';
			if(d.didChange){
				if(isNaN(d.change)) return;
				if(d.changePercent == 'Infinity') d.changePercent = 100;
				if(d.adjustedPercent != 0){
					li = li+(d.adjustedPercent < 0 ? 'decreased by ' : 'increased by ')+Math.abs((parseFloat(d.adjustedPercent) * 100).toFixed(2))+'% weighted from '+getMonthName(fromMonth.getMonth())+' to '+getMonthName(toMonth.getMonth())+'.';
				}else{
					li = li+'did not change and is 0.00%.';
				}
				li += ' Unweighted responses '
				
				if(d.changeType == 'same'){
					li += 'did not change and are ';
				}else{
					li += d.changeType+' by ';
				}
				li += Math.abs(parseFloat(d.change).toFixed(2))+' or '+Math.abs(parseFloat(d.changePercent)).toFixed(2)+'%.';
			}else{
				if(d.previous){
					li = li+(isWithinMonth ? 'decreased by ' : 'is ')+Math.abs(parseFloat(d.change).toFixed(2))+' or 100%';
				}else{
					li = li+(isWithinMonth ? 'increased by ' : 'is ')+Math.abs(parseFloat(d.change).toFixed(2))+' or '+Math.abs(parseFloat(d.changePercent)).toFixed(2)+'%';
				}
			}
			li = li+'</li>';
			infoList.append(li);
		});

		$('#percents').append('<p id="meaning">Weighted: Takes into account the number of residents responding.<br>Un-Weighted: Does not take into account the number of residents responding.</p>');

		$('#graphSubtitle').text('TOTAL QIS INDICATOR ANSWERS BY MONTH');
	}else if(mainGraphFilter == 'compare-star'){
		$('#dateTexts, #daterange').hide();
		$('#percents').prepend('<p id="meaning" style="margin: 0 !important">The Nursing Home Compare Web site features a quality rating system that gives each skilled nursing facilty a rating of between 1 and 5 stars.  Facilities with 5 stars are considered to have much above average quality and facilities with 1 star are considered to have quality much below average.</p>');
		var colors = getPieColors(compareStarPie).values;
		var bullets = {5: 'Much above average', 4: 'Above average', 3: 'Average', 2: 'Below average', 1: 'Much below average'}
		for(var bullet in bullets){
			var li = '<li class="'+(bullet in colors ? '_'+colors[bullet].substr(1, (colors[bullet].length - 1)) : '')+'">'+bullet+' &nbsp;'+bullets[bullet]+'</li>';
			infoList.append(li);
		}
	}
	
	createDropdownFilter('paytype', financialChart.group().all(), $('.financial-subfilter'), 'key', 'key');
	createDropdownFilter('physician', physicianChart.group().all(), $('.physician-subfilter'), 'key', 'key');
	createDropdownFilter('origin', originChart.group().all(), $('.origin-subfilter'), 'key', 'key');
	if(diagnosisChart != undefined){
		$('.diagnosis-subfilter').parent().show().removeClass('hidden');
		var all = diagnosisChart.group().all().splice(0,8);
		all.push({key: 'more', value:{description:'More...'}});
		createDropdownFilter('diagnosis', all, $('.diagnosis-subfilter'), 'key', ['value', 'description']);

		if(diagnosisChart.filters().length != 0){
		    diagnosisChart.filters().forEach(function(d){
		        if($('.filter.active').find('.sub-filters').find('a[data-trigger-filter="'+d+'"][data-chart-filter="diagnosisChart"]').length == 0){
		            $('.filter.active').find('.sub-filters').find('a[data-trigger-filter="more"][data-chart-filter="diagnosisChart"]').addClass('selected');
		        }
		    });
		}

	}else{
		$('.diagnosis-subfilter').parent().hide().addClass('hidden');
	}
	createDropdownFilter('lengthofstay', customFilterValues.lengthofstay.filters, $('.los-subfilter'), 'key', 'key');
	createDropdownFilter('months', customFilterValues.months.filters, $('.months-subfilter'), 'key', 'key');
	createDropdownFilter('readmissions', customFilterValues.readmissions);
	/*singleFilter('distance', geographyDistance, $('.geography-subfilter'), function(filter){
		geographyDistance.forEach(function(d){
			nearbyRange = filter;
			if(filter == d.key){
				d.selected = true;
			}else{
				d.selected = false;
			}
		});
		setCorrectGraphInformation();
		generateMap();
	});*/
	if(indicatorData.length != 0){
		createDropdownFilter('scopeseverity', deficiencyChart.group().all(), $('.scope-severity-subfilter'), 'key', 'text');
		var all = ftagChart.group().all();
		all = all.map(function(d){
			return {key: d.key, value:{description:d.key}};
		});
		if(all.length >= 8){
			all = all.splice(0,8);
			all.push({key: 'more', value:{description:'More...'}});
		}
		createDropdownFilter('ftags', all, $('.ftag-subfilter'), 'key', ['value', 'description']);
		
		all = regulationChart.group().all();
		all = all.map(function(d){
			return {key: d.key, value:{description:d.key}};
		});
		if(all.length >= 8){
			all = all.splice(0,8);
			all.push({key: 'more', value:{description:'More...'}});
		}
		createDropdownFilter('regulations', all, $('.regulation-subfilter'), 'key', ['value', 'description']);
		createDropdownFilter('categories', categoryChart.group().all(), $('.category-subfilter'), 'key', 'key');
		
		if(surveyChart != undefined){
			createDropdownFilter('surveyAnswer', surveyChart.group().all(), $('.survey-answer-subfilter'), 'key', 'text');
			all = ftagSurveyChart.group().all();
			all = all.map(function(d){
				return {key: d.key, value:{description:d.key}};
			});
			if(all.length >= 8){
				all = all.splice(0,8);
				all.push({key: 'more', value:{description:'More...'}});
			}
			createDropdownFilter('ftagSurvey', all, $('.ftag-survey-subfilter'), 'key', ['value', 'description']);
			all = regulationSurveyChart.group().all();
			all = all.map(function(d){
				return {key: d.key, value:{description:d.key}};
			});
			if(all.length >= 8){
				all = all.splice(0,8);
				all.push({key: 'more', value:{description:'More...'}});
			}
			createDropdownFilter('regulationSurvey', all, $('.regulation-survey-subfilter'), 'key', ['value', 'description']);
		}

		if(qisChart != undefined){
			createDropdownFilter('qisAnswer', qisChart.group().all(), $('.qis-answer-subfilter'), 'key', 'text');
			all = ftagQISChart.group().all();
			all = all.map(function(d){
				return {key: d.key, value:{description:d.key}};
			});
			if(all.length >= 8){
				all = all.splice(0,8);
				all.push({key: 'more', value:{description:'More...'}});
			}
			createDropdownFilter('ftagQIS', all, $('.ftag-qis-subfilter'), 'key', ['value', 'description']);
			all = regulationQISChart.group().all();
			all = all.map(function(d){
				return {key: d.key, value:{description:d.key}};
			});
			if(all.length >= 8){
				all = all.splice(0,8);
				all.push({key: 'more', value:{description:'More...'}});
			}
			createDropdownFilter('regulationQIS', all, $('.regulation-qis-subfilter'), 'key', ['value', 'description']);
		}
	}
	if(compareStarPie != undefined){
		singleFilter('compare-star', compareStarRatings, $('.compareratings-subfilter'), function(filter){
			compareStarRatings.forEach(function(d){
				if(filter == d.key){
					d.selected = true;
				}else{
					d.selected = false;
				}
			});
			generateGraphs(true);
		});
		var currentlySelected;
		distanceRatings.forEach(function(d){
			if(d.selected){
				currentlySelected = d;
			}
		});
		if(zip !== false && distanceRatings[0].key != 'zip'){
			distanceRatings.forEach(function(d){
				d.selected = false;
			});
			distanceRatings.unshift({key: 'zip', text: 'ZIP', selected: true});
		}else if(distanceRatings[0].key == 'zip' && zip === false){
			distanceRatings.shift();
			distanceRatings.forEach(function(d){
				if(d.key == 'city'){
					d.selected = true;
				}
			});
			zip = false;
		}else if(zip !== false && currentlySelected.key != nearbyRange){
			distanceRatings.forEach(function(d){
				if(d.key == 'zip'){
					d.selected = true;
				}else{
					d.selected = false;
				}
			});

		}
		singleFilter('distance', distanceRatings, $('.distanceratings-subfilter'), function(filter){
			nearbyRange = filter;
			distanceRatings.forEach(function(d){
				if(filter == d.key){
					d.selected = true;
				}else{
					d.selected = false;
				}
			});
			if($('#searchMapInput').val() == ''){
				zip = false;
			}
			getCompareData(true, undefined, ($('#searchMapInput').val() != '' ? $('#searchMapInput').val() : false));
		});
	}
	$('.filter:not(.active) .sub-filters *').removeClass('selected');
	$('.sub-filters > li').not('.hidden').last().addClass("last");
	disableNoDataFilters();

	//generate our list of filters
	currentlySelectedFilters = {};
	$.each($('.filter.active .sub-filters .sub-filter.selected'), function(index, value){
		if($(this).hasClass('no-inner-sub')){
			currentlySelectedFilters[$(this).text()] = {key: $(this).text(), selected: $(this).text(), inner: false};
		}else{
			var parent = $(this).closest('.inner-sub-filter').parent();
			parent = $($(parent).contents()[0]).text().trim();
			if(!(parent in currentlySelectedFilters)){
				currentlySelectedFilters[parent] = {key: parent, selected: [], inner: true};
			}
			if(parent != 'DIAGNOSIS'){
				currentlySelectedFilters[parent].selected.push($(this).text());
			}else if(parent == 'DIAGNOSIS'){
				var allDiagnoses = diagnosisChart.group();
				var diagnosisFilters = diagnosisChart.filters();
				diagnosisFilters.forEach(function(d){
					if(d in allDiagnoses){
						if(currentlySelectedFilters[parent].selected.indexOf(allDiagnoses[d].description) > -1) return false;
						currentlySelectedFilters[parent].selected.push(allDiagnoses[d].description);
					}
				});
			}
		}
	});
	currentlySelectedFilters = $.map(currentlySelectedFilters, function(value, key){
		if(key == 'MONTHS'){ //check if all are selected
			monthCount = $('.filter.active .sub-filters .months-subfilter > li > a').length;
			if(monthCount == value.selected.length){
				return;
			}
		}
		return value;
	});
	if(currentlySelectedFilters.length != 0){
		var filterList = currFilters.children('ul');
		filterList.empty();
		currentlySelectedFilters.forEach(function(d){
			var html = '<li><div>'+d.key;
			if(d.inner){
				html += '<span class="arrow-right"></span></div><div class="list"><p class="filterText" style="margin: 0 !important; color: #000 !important;">';
				d.selected.forEach(function(f){
					if(d.key == 'S & S'){
						f = f.replace(/([A-Z])/, function(letter){
							return '<b>'+letter+'</b>';
						});
					}
					html += f+', ';
				});
				html = html.substr(0, (html.length - 2))+'</p></div>';
			}else{
				html += '</p></div>'
			}
			html += '</li>';
			filterList.append(html);
		});
		currFilters.show();
		var maxWidth = $(filterList).children('li').eq(0).width() - 20;
		var typeWidth = 0;
		$.each($(filterList).children('li'), function(index, value){
			if(($(this).children().eq(0).width() + 1) > (typeWidth - 20)){
				typeWidth = $(this).children().eq(0).width() + 20;
			}
		});
		$(filterList).find('li').children('div:first-child').css('width', typeWidth+'px');
		$(filterList).find('li').children('div.list').css('width', (maxWidth - typeWidth - 61)+'px');
		if(isTour && $('#demo-filter').data('continueTour') != undefined && $('#demo-filter').data('continueTour') == true){
			$.powerTour('run', [1, 24]);
		}
	}else{
		currFilters.hide();
	}
}

function setupSubfilters(selected, subfilter, currPieFilters){
	var selectedKeys = [];
	for(var i = 0; i < selected.length; i++){
		selectedKeys.push($(selected[i]).attr('data-trigger-filter'));
	}
	currPieFilters = (currPieFilters != undefined ? currPieFilters : false);
	if(currPieFilters != false){
		for(var i = 0; i < currPieFilters.length; i++){
			selectedKeys.push(currPieFilters[i]);
		}
	}
	$(subfilter).empty();
	return selectedKeys;
}

/**
 * Create dropdown menu of a filter
 * @param  {string} mainFilter - mainGraphFilter for this pie
 * @param  {array} options - options from the pies group or custom filter
 * @param  {Object} subfilterUL - DOM object of the UL element
 * @param  {string} filterKey - Key to use to filter the pie
 * @param  {string} textKey - Key to use to display the text of the inner LI element
 */
function createDropdownFilter(mainFilter, options, subfilterUL, filterKey, textKey){
	if(subfilterUL != undefined){
		var selected = subfilterUL.find('.selected');
	}
	var selectedKeys;
	var chart;
	var value;
	var custom = false;
	switch(mainFilter){
		case 'physician':
			selectedKeys = setupSubfilters([], subfilterUL, (physicianOthersChart != undefined ? physicianChart.filters().concat(physicianOthersChart.filters()) : physicianChart.filters()));
			chart = 'physicianChart';
			value = 'value';
			break;
		case 'origin':
			selectedKeys = setupSubfilters([], subfilterUL, (originOthersPie != undefined ? originChart.filters().concat(originOthersPie.filters()) : originChart.filters()));
			chart = 'originChart';
			value = 'value';
			break;
		case 'diagnosis':
			selectedKeys = setupSubfilters([], subfilterUL, diagnosisChart.filters());
			chart = 'diagnosisChart';
			value = 'value.count';
			break;
		case 'paytype':
			var filters = financialChart.filters().concat(admissionsChart.filters()).concat(dischargesChart.filters()).concat(lengthofstayChart.filters()).unique();
			selectedKeys = setupSubfilters([], subfilterUL, filters);
			chart = 'financialChart';
			value = 'value';
			break;
		case 'lengthofstay':
			selectedKeys = setupSubfilters(selected, subfilterUL, []);
			chart = 'lengthofstay';
			custom = true;
			break;
		case 'months':
			var monthFilters = customFilterValues.months.filters;
			var monthFilterKeys = [];
			for(var i = 0; i < monthFilters.length; i++){
				if(monthFilters[i].selected){
					monthFilterKeys.push(monthFilters[i].key);
				}
			}
			selectedKeys = setupSubfilters([], subfilterUL, monthFilterKeys);
			chart = 'months';
			custom = true;
			break;
		case 'readmissions':
			chart = 'readmissions';
			custom = true;
			break;
		case 'scopeseverity':
			options.forEach(function(d){
				if(deficiencyValues[d.key]){
                	d.text = d.key+' - '+deficiencyValues[d.key];
            	}
			});
			selectedKeys = setupSubfilters([], subfilterUL, deficiencyChart.filters());
			chart = 'deficiencyChart';
			value = 'value';
			break;
		case 'ftags':
			selectedKeys = setupSubfilters([], subfilterUL, ftagChart.filters());
			chart = 'ftagChart';
			value = 'value';
			break;
		case 'regulations':
			selectedKeys = setupSubfilters([], subfilterUL, regulationChart.filters());
			chart = 'regulationChart';
			value = 'value';
			break;
		case 'categories':
			selectedKeys = setupSubfilters([], subfilterUL, categoryChart.filters());
			chart = 'categoryChart';
			value = 'value';
			break;
		case 'surveyAnswer':
			options.forEach(function(d){
				if(answerValues[d.key]){
                	d.text = answerValues[d.key];
            	}
			});
			selectedKeys = setupSubfilters([], subfilterUL, surveyChart.filters());
			chart = 'surveyChart';
			value = 'value';
			break;
		case 'ftagSurvey':
			selectedKeys = setupSubfilters([], subfilterUL, ftagSurveyChart.filters());
			chart = 'ftagSurveyChart';
			value = 'value';
			break;
		case 'regulationSurvey':
			selectedKeys = setupSubfilters([], subfilterUL, regulationSurveyChart.filters());
			chart = 'regulationSurveyChart';
			value = 'value';
			break;
		case 'qisAnswer':
			options.forEach(function(d){
				if(d.key == "2"){
                	d.text = 'NO';
            	}else{
            		d.text = 'YES';
            	}
			});
			selectedKeys = setupSubfilters([], subfilterUL, qisChart.filters());
			chart = 'qisChart';
			value = 'value';
			break;
		case 'ftagQIS':
			selectedKeys = setupSubfilters([], subfilterUL, ftagQISChart.filters());
			chart = 'ftagQISChart';
			value = 'value';
			break;
		case 'regulationQIS':
			selectedKeys = setupSubfilters([], subfilterUL, regulationQISChart.filters());
			chart = 'regulationQISChart';
			value = 'value';
			break;
		default:
			selectedKeys = [];
			chart = '';
	}
	if(subfilterUL != undefined){
		options.forEach(function(d){
			subfilterUL.append('<li><a href="#" class="sub-filter '+(selectedKeys.indexOf(d[filterKey]) > -1 ? 'selected' : '')+'" data-value-accessor="'+value+'" data-custom-filter="'+custom+'" data-chart-filter="'+chart+'" data-trigger-filter="'+d[filterKey]+'">'+(Array.isArray(textKey) ? d[textKey[0]][textKey[1]] : d[textKey])+'</a></li>');
		});
		if(selectedKeys.length != 0){
			subfilterUL.parent().addClass('selected');
		}else{
			subfilterUL.parent().removeClass('selected');
		}
	}else{
		options.element.data('no-sub', options);
		if(options.selected){
			options.element.addClass('selected');
		}else{
			options.element.removeClass('selected');
		}
	}
}

function disableNoDataFilters(){
	$('.filter.active .inner-sub-filter li > a[data-custom-filter="true"]').each(function(index, value){
		var chartToFilter = $(this).attr('data-chart-filter');
		var filter = $(this).attr('data-trigger-filter');
		if('check' in customFilterValues[chartToFilter]){
			var result = customFilterValues[chartToFilter].check(filter);
			if(!result){
				$(this).addClass('disabled').removeClass('selected');
			}
		}
	});
	$('.filter.active .inner-sub-filter li > a[data-custom-filter="false"]').each(function(index, value){
		if(!$(this).hasClass('selected')){
			var chartToFilter = $(this).attr('data-chart-filter');
			var filter = $(this).attr('data-trigger-filter');
			var valueAccessor = $(this).attr('data-value-accessor');
			if(chartToFilter in window && filter != 'more'){
				var isData = window[chartToFilter].group().all();
				var that = this;
				isData.forEach(function(d){
					if(d.key == filter){
						if(Object.resolve(valueAccessor,d) == 0){
							$(that).addClass('disabled');
						}
					}
				});
			}
		}
	});
}

function singleFilter(mainFilter, options, subfilterUL, dealerFunc){
	if(dealerFunc == undefined){dealerFunc = function(){}}
	subfilterUL.empty();
	if(subfilterUL != undefined){
		var selected = subfilterUL.find('.selected');
	}
	var selectedKey = '';
	switch(mainFilter){
		case 'compare-star':
			selectedKey = getActiveSimpleFilter(options);
			chart = '';
			break;
		case 'distance':
			selectedKey = getActiveSimpleFilter(options);
			chart = '';
			break;
		default:
			selectedKeys = '';
			chart = '';
	}
	options.forEach(function(d){
		var li = $('<li><a href="#" class="sub-filter '+(d.key == selectedKey ? 'selected' : '')+'" data-custom-filter="single" data-chart-filter="'+chart+'" data-trigger-filter="'+d.key+'">'+d.text+'</a></li>').appendTo(subfilterUL);
		li.children().eq(0).data('do-function', dealerFunc);
	});
	if(selectedKey.length != 0){
		subfilterUL.parent().addClass('selected');
	}else{
		subfilterUL.parent().removeClass('selected');
	}
}

function formatGraphData(formatArray){
	var isGraphData = false;
	if(formatArray == undefined){
		formatArray = graphData;
		isGraphData = true;
	}
	var allDiagnoses = {};
	formatArray.forEach(function(d, i){
		if(typeof d.admit_dt == 'object'){
			d.admit_dt = dateFormat(d.admit_dt);
		}else{
			d.admit_dt = dateFormat.parse(d.admit_dt);
		}
		if(d.discharge_dt != 'In-house'){
			if(typeof d.discharge_dt == 'object'){
				d.discharge_dt = dateFormat.parse(d.discharge_dt);
			}else{
				d.discharge_dt = dateFormat.parse(d.discharge_dt);
			}
		}
		if(d.diagnosis.length == 0){
			d.diagnosis.push({"DIAGNOSIS_CODE": "None"});
		}else{
			haveDiagnosis = true;
			d.diagnosis.forEach(function(i){
				if(i.DIAGNOSIS_CODE != undefined){
					if(typeof i.DIAGNOSIS_CODE == 'string')
					{
						i.DIAGNOSIS_CODE = i.DIAGNOSIS_CODE.replace('.', '');
					}
					else
					{
						i.DIAGNOSIS_CODE = i.DIAGNOSIS_CODE[0].replace('.', '');
					}	
				}
			});
		}
		if(d.financial_change != undefined && d.financial_change != ''){
			var financialChanges = [];
			for(var changeUNIX in d.financial_change){
				var date = new Date(changeUNIX * 1000);
				if(financialChanges[financialChanges.length - 1] != d.financial_change[changeUNIX]){
					financialChanges.push(d.financial_change[changeUNIX]);
					d.financial_change[dateFormat(date)] = d.financial_change[changeUNIX];
					if(d.discharge_dt != 'In-house' && dateFormat(date) == dateFormat(d.discharge_dt)){
						delete d.financial_change[dateFormat(date)];
					}
				}
				delete d.financial_change[changeUNIX];
			}
			financialChanges = [];
		}
	});

	var residentsWithIndicators = formatArray.filter(function(resident){
		if(resident.indicators.length != 0){
			return true;
		}
	});
	indicatorData = parseIndicatorData(indicatorData, false);
	var task_details = mapTaskDetails(indicatorData);
	mapIndicatorsToResidents(indicatorData, residentsWithIndicators, task_details);

	surveyData = parseIndicatorData(surveyData, true);
	task_details = mapTaskDetails(surveyData);
	mapIndicatorsToResidents(surveyData, residentsWithIndicators, task_details);

	qisData = parseIndicatorData(qisData, true);
	task_details = mapTaskDetails(qisData);
	mapIndicatorsToResidents(qisData, residentsWithIndicators, task_details);

	if(isGraphData){
		graphData = formatArray;
	}else{
		return formatArray;
	}
}

function mapIndicatorsToResidents(data, residents, task_details){
	residents.forEach(function(resident){
		var name = resident.name.replace(/\w\S*/g, function(word){return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();});
		resident.indicators.forEach(function(indicator){
			var match = task_details.search(indicator.task_detail, 'id');
			if(match != undefined){
				var matchingNameIndex = data[match.index].samples.indexOf(name);
				if(matchingNameIndex !== -1){
					data[match.index].samples[matchingNameIndex] = resident;
				}
			}
		});
	});
}

function mapTaskDetails(data){
	return data.map(function(indicator, i){
		return {id: indicator.td_uid, index: i};
	});
}

function parseIndicatorData(data, isSurvey){
	if(data == undefined){
		return [];
	}
	for(var d = 0; d < data.length; d++){
		if(data[d].last_updated == undefined || data[d].last_updated == '') continue;
		try{
			data[d].last_updated = dateFormat.parse(data[d].last_updated);
		}catch(err){
			continue;
		}
		if(data[d].no != null && data[d].no != "" && data[d].no != '""' && data[d].no != [] && data[d].no != null){
			data[d].no = data[d].no;
			if(!Array.isArray(data[d].no) && !isSurvey){
				data[d].no = $.map(data[d].no, function(value, index){
					return value;
				});
			}
		}else{
			data[d].no = [];
		}

		if(data[d].yes != null && data[d].yes != "" && data[d].yes != '""' && data[d].yes != [] && data[d].yes != null){
			try{
				data[d].yes = data[d].yes;
			}catch(err){
				continue;
			}
			if(!Array.isArray(data[d].yes) && !isSurvey){
				data[d].yes = $.map(data[d].yes, function(value, index){
					return value;
				});
			}
		}else{
			data[d].yes = [];
		}
		if(data[d].samples != "" && data[d].samples != '""' && data[d].samples != [] && data[d].samples != null){
			data[d].samples = data[d].samples.filter(function(resident){
				if(typeof resident == 'object') resident = resident.name.toString();
				if(resident != '' && resident != '""' && resident.trim().length !== 0){
					return true;
				}else{
					return false;
				}
			});
		}else{
			if(d != 0){
				data.splice(d,1);
				d--;
			}
		}
		if(data[d].user_comments != "" && data[d].user_comments != '""'){
			try{
				data[d].user_comments = JSON.parse(data[d].user_comments);
			}catch(e){
				data[d].user_comments = data[d].user_comments;
			}
		}else{
			data[d].user_comments = false;
		}
		if((data[d].tag == null || data[d].tag == "") && (data[d].department == 'Facility Standards')){
			data[d].tag = 'FS';
		}
		if((data[d].tag == null || data[d].tag == "") && (data[d].department == 'Surveys')){
			data[d].tag = 'SV';
		}
		if(isSurvey){
			for(var sample in data[d].yes){
				if(data[d].yes[sample] == 0){
					delete data[d].yes[sample];
				}
			}
			data[d].answers = data[d].yes;
			if(data[d].ind_survey_yes_no == 1 && data[d].ind_dep_count < 167){
				for(var sample in data[d].answers){
					if(data[d].answers[sample] == 1){
						data[d].answers[sample] = 5;
					}else if(data[d].answers[sample] == 2){
						data[d].answers[sample] = 1;
					}
				}
			}
			delete data[d].yes;
			data[d].assignedMonthYear = dateFormat(new Date(data[d].year, data[d].month));
			data[d].assignedMonthYear = dateFormat.parse(data[d].assignedMonthYear);
		}
	};
	if(isSurvey){
		data = data.filter(function(d){
			if(d.answers != null && d.samples != null && d.samples != []){
				return d;
			}
		});
	}
	return data;
}

function removeDataForAdmissions(){
	for(var i = 0; i < graphData.length; i++){
		if(!isWithinTimeRange(graphData[i].admit_dt)){
			removedData.push(graphData[i]);
			graphData.splice(i, 1);
			i--;
		}else{
			indexForID(graphData[i].id, i);
		}
	}
}

function addBackData(){
	if(removedData.length > 0){
		graphData = graphData.concat(removedData);
	}
	checkIfChangePayResidents();
	notRemovedData = [];
	removedData = [];
	hmpIndex = {};
}

function removeDataForDischarges(){
	for(var i = 0; i < graphData.length; i++){
		if(graphData[i].discharge_dt == 'In-house'){
			removedData.push(graphData[i]);
			graphData.splice(i, 1);
			i--;
		}else{
			var withinMonth = d3.time.day(graphData[i].discharge_dt);
			var to = $('#to').datepicker('getDate');
			var from = $('#from').datepicker('getDate');
			if(withinMonth > to || from > withinMonth){
				removedData.push(graphData[i]);
				graphData.splice(i, 1);
				i--;
			}else{
				notRemovedData.push(graphData[i]);
				indexForID(graphData[i].id, i);
			}
		}
	}
}

function checkIfChangePayResidents(){
	if(changePayorResidentsOrig.length != 0){
		var tmpResidents = [];
		for(var i = 0; i < graphData.length; i++){
			if(!graphData[i].payChange){
				tmpResidents.push(graphData[i]);
			}
		}
		graphData = tmpResidents;
		graphData = graphData.concat(changePayorResidentsOrig);
		changePayorResidentsOrig = [];
	}
}

function removeDataForLOS(returnOkay){
	if(returnOkay == undefined){returnOkay = false;}
	var returnData = [];
	for(var i = 0; i < graphData.length; i++){
		if(graphData[i]['LOS'] == 'Unknown' || !isWithinTimeRange(d3.time.day(graphData[i].admit_dt))){
			if(!returnOkay){
				removedData.push(graphData[i]);
				graphData.splice(i, 1);
				i--;
			}
		}else{
			if(returnOkay){
				returnData.push(graphData[i]);
			}else{
				notRemovedData.push(graphData[i]);
				indexForID(graphData[i].id, i);
				if(graphData[i].financial_change != undefined && Object.keys(graphData[i].financial_change).length > 1){
					var datesToUse = Object.keys(graphData[i].financial_change);
					for(var d = 0; d < datesToUse.length; d++){
						if(d != 0 && (Math.abs(new Date(datesToUse[d].replace(/-/g, "/")).getTime() - new Date(datesToUse[d-1].replace(/-/g, "/")).getTime()) / 3600000) <= 24){
							datesToUse.splice(d-1,1);
						}
					}
					if(datesToUse.length <= 1) continue;
					//changePayorResidentsOrig.push(jQuery.extend(true, {}, graphData[i]));
					//var realDischarge = graphData[i].discharge_dt;
					if(!graphData[i].USE_LOS){
						removedData.push(graphData[i]);
						graphData.splice(i, 1);
						i--;
					}else{
						graphData[i].discharge_dt = dateFormat.parse(datesToUse[datesToUse.length-1]);
					}
					//graphData[i].LOS = daydiff(new Date(graphData[i].admit_dt), new Date(graphData[i].discharge_dt));
					//graphData[i]['payChange'] = true;
					//datesToUse.splice(0, 1); //remove the last one because we already have a record that will be using it
					//create more records for each different payor
					// datesToUse.forEach(function(d, c){
					// 	var newRecord = jQuery.extend(true, {}, graphData[i]);
					// 	newRecord.admit_dt = dateFormat.parse(datesToUse[c]);
					// 	if(c == datesToUse.length - 1){
					// 		if(realDischarge != 'In-house'){
					// 			try{
					// 				realDischarge = dateFormat.parse(realDischarge);
					// 			}catch(err){
					// 				realDischarge = new Date(realDischarge);
					// 			}
					// 		}
					// 		newRecord.discharge_dt = realDischarge;
					// 	}else{
					// 		newRecord.discharge_dt = dateFormat.parse(datesToUse[c + 1]);
					// 	}
					// 	newRecord.LOS = daydiff(newRecord.admit_dt, (newRecord.discharge_dt == 'In-house' ? new Date() : newRecord.discharge_dt));
					// 	newRecord.financial = graphData[i].financial_change[d];
					// 	var changeDate = dateFormat.parse(d);
					// 	newRecord.financial_change = {};
					// 	newRecord.financial_change[changeDate] = graphData[i].financial_change[d];
					// 	var index = graphData.push(newRecord);
					// 	indexForID(graphData[i].id, index - 1);
					// });
				}
			}
		}
	}
	if(returnOkay){
		return returnData;
	}
}

function createCensusData(data, maxDischarge){
	var census = {};
	data.map(function(cen){
		census[cen.id] = cen.days;
	});
	if(outOfRangeCensusResidents.length != 0){
		outOfRangeCensusResidents = formatGraphData(outOfRangeCensusResidents);
		graphData = graphData.concat(outOfRangeCensusResidents);
		outOfRangeCensusResidents = [];
	}

	var tmpGraphData = graphData.slice(0),
		minDate = new Date($('#from').datepicker('getDate'));
		var months = monthDiff(new Date($('#from').datepicker('getDate')), new Date($('#to').datepicker('getDate'))),
			idStartDate = {};

		graphData = [];

		// if(months > 1)
		// {
		// 	var monthsBetween = [];
		// 	var datFrom = new Date('1 ' + monthFormat($('#from').datepicker('getDate')));
		// 	var datTo = new Date('1 ' + monthFormat($('#to').datepicker('getDate')));
		// 	var fromYear =  datFrom.getFullYear();
		// 	var toYear =  datTo.getFullYear();
		// 	var diffYear = (12 * (toYear - fromYear)) + datTo.getMonth();

		// 	for (var i = datFrom.getMonth(); i <= diffYear; i++) {
		// 	    monthsBetween.push((new Date(Math.floor(fromYear+(i/12)), (i%12), 0).getDate()))
		// 	}
		// 	console.log(monthsBetween);
		// }

	for(var i = 0; i < tmpGraphData.length; i++){
		var admitDate = new Date(tmpGraphData[i].admit_dt),
			dischargeDate = new Date((tmpGraphData[i].discharge_dt == 'In-house' ? dateFormat(new Date(maxDischarge)) : dateFormat(tmpGraphData[i].discharge_dt)));

		// if(admitDate != dischargeDate){
			if(parseInt(tmpGraphData[i].id) in census){
				var start = 0;
				if(admitDate < minDate){
					start = daydiff(admitDate, minDate);
					census[parseInt(tmpGraphData[i].id)] = parseInt(census[parseInt(tmpGraphData[i].id)]) + start;
				}
				for(var c = start; c <= census[parseInt(tmpGraphData[i].id)]; c++){
					var newAdmitDate = new Date(admitDate.getTime());
					// if(dischargeDate < newAdmitDate) break;
					newAdmitDate.setDate(newAdmitDate.getDate() + c);
					if(newAdmitDate.getTime() > maxDischarge) break;
					if(minDate > newAdmitDate) continue;
					if(dischargeDate.toDateString() === newAdmitDate.toDateString() && dischargeDate.getTime() != maxDischarge) break;
					var newPatientRecord = Object.create(tmpGraphData[i]);
					newPatientRecord.admit_dt = newAdmitDate;
					var index = graphData.push(newPatientRecord);
					indexForID(tmpGraphData[i].id, index-1);
				}
			}
		// }
	}
}

function getPaytypes(){
	var paytypes = []
	graphData.forEach(function(d){
		for(var date in d.financial_change){
			if(paytypes.indexOf(d.financial_change[date]) == -1){
				paytypes.push(d.financial_change[date]);
			}
		}
	});
	return paytypes;
}

function indexForID(id, i){
	if(!(id in hmpIndex)){
		hmpIndex[id] = [];
	}
	hmpIndex[id].push(i);
}


//remove people from graph
$(document).on('click', '.removePerson', function(e){
	e.preventDefault();
	var id = $(this).data('id');
	for(var i = 0; i < graphData.length; i++){
		if(graphData[i]['id'] == id){
			removedResidents.push(graphData[i]);
			graphData.splice(i, 1);
			break;
		}
	}
	removeResidentRefresh = true;
	generateGraphs(true);
});
//remove facilites from graph
$(document).on('click', '.removeFacility', function(e){
	e.preventDefault();
	var id = $(this).data('id');
	for(var i = 0; i < compareData.length; i++){
		if(compareData[i].federal_provider_number == id){
			removedFacilities.push(compareData[i]);
			compareData.splice(i, 1);
			break;
		}
	}
	removeResidentRefresh = true;
	generateGraphs(true);
});

//add people back to graph
$(document).on('click', '.refreshTable', function(e){
    e.preventDefault();
    $('.filter').children('.filter-chart').css({'background': 'none', 'border-color': '#fff'});
    removeResidentRefresh = false;
    generateGraphs(true);
});

function getFilterOnDeleteResidentData(){
	filters['financial'] = financialChart.filters();
	filters['discharges'] = dischargesChart.filters();
	filters['admissions'] = admissionsChart.filters();
	filters['lengthofstay'] = lengthofstayChart.filters();
	filters['lengthofstaytotal'] = lengthofstayChart.filters();
	filters['physician'] = physicianChart.filters();
	filters['origin'] = originChart.filters();
	if(diagnosisChart != undefined){
		filters['diagnosis'] = diagnosisChart.filters();
	}
	filters['rawreadmission'] = rawreadmissionChart.filters();
	filters['riskadjusted'] = riskadjustedChart.filters();
	if(censusChart != undefined){
		filters['census'] = censusChart.filters();
	}
}

function restoreFilterData(){
	for(var i = 0; i < filters['financial'].length; i++){
		financialChart.filter(filters['financial'][i]);
	}
	for(var i = 0; i < filters['discharges'].length; i++){
		dischargesChart.filter(filters['discharges'][i]);
	}
	for(var i = 0; i < filters['admissions'].length; i++){
		admissionsChart.filter(filters['admissions'][i]);
	}
	for(var i = 0; i < filters['lengthofstay'].length; i++){
		lengthofstayChart.filter(filters['lengthofstay'][i]);
	}
	for(var i = 0; i < filters['lengthofstaytotal'].length; i++){
		lengthofstayChart.filter(filters['lengthofstaytotal'][i]);
	}
	for(var i = 0; i < filters['physician'].length; i++){
		physicianChart.filter(filters['physician'][i]);
	}
	for(var i = 0; i < filters['origin'].length; i++){
		originChart.filter(filters['origin'][i]);
	}
	for(var i = 0; i < filters['diagnosis'].length; i++){
		diagnosisChart.filter(filters['diagnosis'][i]);
	}
	for(var i = 0; i < filters['rawreadmission'].length; i++){
		rawreadmissionChart.filter(filters['rawreadmission'][i]);
	}
	for(var i = 0; i < filters['riskadjusted'].length; i++){
		riskadjustedChart.filter(filters['riskadjusted'][i]);
	}
	if(censusChart != undefined){
		for(var i = 0; i < filters['census'].length; i++){
			censusChart.filter(filters['census'][i]);
		}
	}
}

function addBackDeletedResident(){
	graphData = graphData.concat(removedResidents);
	compareData = compareData.concat(removedFacilities);
	removedResidents = [];
	removedFacilities = [];
}

function holdItInPlace(event, ui) {        
    $( ".draggable" ).css({
        position: "relative !important",
        top: "0 !important",
        left: "0 !important"
    });
}

function removePopUpAndOverlay(specialClass, removeRelativeFromBody, removeBodyClass){
	if(mainGraphFilter == 'compare-star') {
		$('#graph-details').append($('#map'));
		$('#map').css('top', $('map').data('top-value'));
	}
	specialClass = (typeof specialClass === 'undefined') ? '' : '.'+specialClass;
	removeBodyClass = (typeof removeBodyClass === 'undefined') ? false : removeBodyClass;
	removeRelativeFromBody = (typeof removeRelativeFromBody === 'undefined') ? false : removeRelativeFromBody;
	$('.pop_up'+specialClass+', .overlay').remove();
	if(removeBodyClass != false){
		$('body').removeClass(removeBodyClass);
	}
	if(removeRelativeFromBody){
		$('body').removeClass('relative');
	}
}
var mapImage = null
	mapData = {},
	mapImageAjax = null;
$('#print').click(function(e){
	var residentsTableChecked = [];
	if(mainGraphFilter == 'admissions'){
		residentsTableChecked = ['residentsName', 'dateRange', 'residentsAdmitDate', 'residentsPhysician', 'residentsPaytype'];
	}else if(mainGraphFilter == 'discharges'){
		residentsTableChecked = ['residentsName', 'dateRange', 'residentsDischargeDate', 'residentsPhysician', 'residentsPaytype', 'residentsLOS'];
	}else if(mainGraphFilter == 'paytype'){
		residentsTableChecked = ['residentsName', 'dateRange', 'residentsPaytype', 'residentsPhysician', 'residentsAdmitDate'];
	}else if(mainGraphFilter == 'physician'){
		residentsTableChecked = ['residentsName', 'dateRange', 'residentsPhysician', 'residentsAdmitDate', 'residentsDischargeDate'];
	}else if(mainGraphFilter == 'origin'){
		residentsTableChecked = ['residentsName', 'dateRange', 'residentsAdmitDate', 'residentsAdmitedFrom'];
	}else if(mainGraphFilter == 'rawreadmission' || mainGraphFilter == 'riskadjusted'){
		residentsTableChecked = ['residentsName', 'dateRange', 'residentsAdmitDate', 'residentsDischargeDate'];
	}else if(mainGraphFilter == 'lengthofstay' || mainGraphFilter == 'lengthofstaytotal'){
		residentsTableChecked = ['residentsName', 'dateRange', 'residentsAdmitDate', 'residentsDischargeDate', 'residentsPaytype', 'residentsLOS'];
	}else if(mainGraphFilter == 'census'){
		residentsTableChecked = ['residentsName', 'dateRange', 'residentsPaytype', 'residentsDischargeDate'];
	}

	var html = $('#printPop').html();
	var bottomButtons = '<div class="text-right" id="popup_buttons">';
			bottomButtons += '<button id="cancelButton" onclick="removePopUpAndOverlay(undefined, true, \'noscroll\');if(mapImageAjax != null){mapImageAjax.abort();mapImageAjax=null;mapData={}}">Cancel</button> <button id="printGo">Print</button>';
	bottomButtons += '</div>';
	$('body').addClass('relative');
	popup(html, 'body', 'wide bodynoscroll analyticsPrint', true, '2.5%', bottomButtons, 'noscroll');
	$('.pop_up, #popup_buttons').css('background-color', '#fff');
	$('.hasResidents.active li.active').removeClass('active');
	$('.pop_up .tableCheck input').attr('checked', false);
	for(var i = 0; i < residentsTableChecked.length; i++){
		$('.pop_up input[name="'+residentsTableChecked[i]+'"]').attr('checked', true);
		$('.hasResidents.active li[data-print-filter="'+residentsTableChecked[i]+'"]').addClass('active');
	}

	var pdfData = createGraphImage();
	$('.filterSelectors').hide();
	$('#report-preview').html('<p style="text-align:center;"><img src="/assets/images/ajax-loader.gif" /></p>');
	$.post('/analytics/facility/print', pdfData, null, 'json')
	.done(function(data){

		$('#report-preview').html(data.htmlPreview);

		$('#statsHolder tr').each(function(i, tr) {
			var classes = $(tr).attr('class');
			if(classes !== undefined) {
				hexColor = '#' + (classes.split(' ')[0]).substr(1);
				$('td', tr).each(function(i, td) {
					$(td).css('background-color', hexColor);
				});
				$(tr).children('td').not(':first-child').css('text-align', 'center');
			}
		});

		$('#statsHolder .indicators td, #statsHolder .indicators th').each(function(i, td) {
			var classes = $(td).attr('class');
			if(classes !== undefined) {
				hexColor = '#' + (classes.split(' ')[0]).substr(1);
				$(td).css('background-color', hexColor).css('text-align', 'center');
			}
			$(td).css('font-size', '160%');
		});

		$('#statsHolder li').each(function(i, li) {
			var classes = $(li).attr('class');
			if(classes !== undefined) hexColor = '#' + (classes.split(' ')[0]).substr(1);			
			else hexColor = '#000';	
			$(li).css('list-style', 'none').prepend('<span style="color:' + hexColor + ';">&bull;</span> ');	
		});

		$('#residents').css('top', (parseInt($('#statsHolder').css('top')) + parseInt($('#statsHolder').css('height')) + 15) + 'px');

		if(
		   mainGraphFilter == 'surveys' ||
		   mainGraphFilter == 'deficiencies' ||
		   mainGraphFilter == 'qis' ||
		   mainGraphFilter == 'compare-star') {
			$('#residents table').replaceWith('<table id="residents-table">' + $('.dataTable thead').html() + $('#resident-table').html() + '</table>');
			$('#residents table thead, #residents table tr td a.removePerson, #residents table tr th a, a.removeFacility').remove();
			if(mainGraphFilter == 'compare-star') {
				$('#residents table').css('margin-bottom', '20px');
				$('#residents h1').text('Facilities');
			}
		} else {
			$('.filterSelectors').show();
		}

		function resizePreview(){
			$( ".draggable" ).css({
	          position: "relative !important",
	          top: "0 !important",
	          left: "0 !important"
	      });
		};
		function resizeStart(){
			$( ".draggable" ).css({
			    position: "relative !important",
			    top: "0 !important",
			    left: "0 !important"
			});
		};
		function resizeStop(){
			$( ".draggable" ).css({
			    position: "relative !important",
			    top: "0 !important",
			    left: "0 !important"
			});
		}

		var graphLegend = $('#graphLegend');

		graphLegend.draggable({
			containment: '#report-preview',
			grid: [10,10]
		});

		$('#statsHolder, #residents').draggable({
			containment: '#report-preview-inner',
			grid: [10,10]
		}).resizable({
			containment: "#report-preview-inner",
			resize: resizePreview(),
			start: resizeStart(),
		  	stop: resizeStop()
		});

		$("#chart-iamge").draggable({
		  drag: function( event, ui ) {
		  	if(isTour){
		  		resizePosition(false);
		  	}
		  },
		  containment: "#report-preview-inner",
		  grid: [ 10, 10 ]
		})
		.resizable({
		  containment: "#report-preview-inner",
		  aspectRatio: true,
		  resize: function( event, ui ){
		  	resizePreview();
		  	if(isTour){
		  		resizePosition(false);
		  	}
		  },
		  start: resizeStart(),
		  stop: resizeStop()
		});


		$('.relative-wrapper #chart-iamge img').on("load", function() {

			var chatBox = $('.relative-wrapper #chart-iamge'),
				statsBox = $('.relative-wrapper #statsHolder'),
				residentBox = $('.relative-wrapper #residents');
			
			var statsBoxTop = (parseInt(chatBox.css('top')) + chatBox.height()) + 10,
				residentChart = (statsBoxTop + statsBox.height()) + 40;

			$(statsBox).css('top', statsBoxTop + 'px');
			$(residentBox).css('top', residentChart + 'px');
				
		});

		$('#report-preview').scroll(function(){
			if(isTour){
				resizePosition(false);
			}
		});
		if(isTour){
			$('.overlay').remove();
			$('.pop_up.wide').css({'height': '88%'});
			if(tourStep == 25){
				$.powerTour('navigation', ["goto", 26]);
			}else{
				$.powerTour('navigation', 'prev');
			}
		}

		if(mainGraphFilter == 'compare-star'){
			$('#printGo').attr('disabled', true);
			$('#report-preview-inner > .relative-wrapper').append('<div id="mapImageWrapper"  class="draggable" style="width: 100%; top: '+($('#residents').position().top+$('#residents').height()-107)+'px; margin-bottom: 20px;"><img src="/assets/images/ajax-loader.gif" id="mapImage" style="display: block; margin: 0px auto;"/><h3 class="text-center" style="margin-top: 8px;">Loading Map</h3></div>');
			var filter = 'overall_rating';
			compareStarRatings.forEach(function(d){
			    if(d.selected){
			        filter = d.key;
			    }
			});

			var tmpMapData = {
				lat: map.getCenter().lat(),
				lng: map.getCenter().lng(),
				zoom: map.getZoom(),
				range: nearbyRange,
				rangeInput: (nearbyRange == 'state' ? thisFacilityData.realState+'_'+filter : filter),
				mainGraphFilter: mainGraphFilter,
				zip: 0
			};

			if(zip !== false){
				tmpMapData['zip'] = zip+'::'+newLocal[zip].readable.city.replace(' ', '_')+'::'+newLocal[zip].readable.county.replace(' ', '_')+'::'+newLocal[zip].readable.state.replace(' ', '_');
			}

			if(objectsAreSame(tmpMapData, mapData)){
				haveMapImage();
			}else{
				mapData = tmpMapData;
				mapImageAjax = $.ajax({
				    type: "POST",
				    url: '/analytics/facility/mapImage'+(usr_assoc_id != '' ? '?usr_assoc_id='+usr_assoc_id : ''),
				    datatype: "image",
				    data: {mapImageData: JSON.stringify(mapData)},
				    async: true
				}).done(function(data){
					mapImage = data;
					haveMapImage();
					mapImageAjax = null;
				});
			}

			function haveMapImage(){
				$('#printGo').attr('disabled', false);
				$('#mapImageWrapper > h3').remove();
				$('#mapImage').attr('src', '');
				$('#mapImage').attr('src', '/analytics/facility/image/'+mapImage);
				$('#mapImage').attr('width', '576px').attr('height', '523px').css({margin: 'inherit'});
				$('#mapImageWrapper').css('width', 'auto');
				$('#mapImageWrapper').draggable({
					containment: '#report-preview-inner',
					grid: [10,10]
				});
				$('#mapImageWrapper').css('left', (($('#report-preview-inner').width() / 2) - (523 / 2) - 20)+'px');
				$('#mapImage').resizable({
					containment: "#report-preview-inner",
					resize: resizePreview(),
					start: resizeStart(),
				  	stop: resizeStop(),
				  	aspectRatio: true,
				  	maxWidth: 576,
				  	maxHeight: 523
				});
				$('#report-preview-inner').css('min-height', parseInt($('#report-preview-inner').css('min-height')) + 523 + 'px');
			}
		}

	    // popUpMsg('To print your analytics please <a href="' + data.link + '" target="_blank">click here</a> and download the pdf version.</p>');
	})
	.fail(function(text){
		removePopUpAndOverlay();
	    popUpMsg('Something went wrong! Try again');
	});

});

$(document).on('click', '.reset', function(e){
	e.preventDefault();

	var inputs = $(this).closest('.area').children('.inputs');
	$(inputs).find('input[type="text"]').val('');
	$(inputs).find('input[type="checkbox"]').attr('checked', false);

	return false;
});

$(document).on('click', '.checkAll', function(e){
	e.preventDefault();
	if($(this).attr('data-max') !== undefined){
		$(this).siblings('.checkboxes').find('input[type="checkbox"]:not(.deselectGroup):lt('+$(this).data('max')+')').attr('checked', true);
	}else{
		$(this).siblings('.checkboxes').find('input[type="checkbox"]:not(.deselectGroup)').attr('checked', true);
	}
	$(this).siblings('.checkboxes').find('.deselectGroup').attr('checked', false).attr('data-active', 'false');
	return false;
});

$(document).on('change', '.checkboxes input[type="checkbox"]', function(){
	var parent = $(this).closest('.checkboxes');
	if($(this).hasClass('deselectGroup')){
		if($(this).attr('data-active') == 'false'){
			var parent = $(this).closest('.checkboxes');
			$(parent).find('input[type="checkbox"]').attr('checked', false);
			$(this).attr('checked', true);
			$(this).attr('data-active', 'true');
		}else{
			$(this).attr('checked', false);
			$(this).attr('data-active', 'false')
		}
	}else{
		if($(parent).find('.deselectGroup').attr('data-active') == 'true'){
			$(this).attr('checked', false);
		}
		if($(parent).attr('data-max') !== undefined){
			var max = $(parent).attr('data-max');
			if($(parent).find('input[type="checkbox"]:checked').length > max){
				$(this).attr('checked', false);
			}
		}
	}
});

$(document).on('click', '.filterSelectors li', function() {
	if($(this).hasClass('title') || $(this).hasClass('inactive')) return;
	$(this).toggleClass('active');

	var filter = $(this).data('print-filter');
	
	if(filter == 'chartDisplay') $('ul.hasGraph').toggle($(this).hasClass('active'));

	if(filter == 'noResidents') $('ul.hasResidents').toggle($(this).hasClass('active'));

	$('.area input[name="' + filter + '"]').attr('checked', $(this).hasClass('active'));

	if(filter == 'dateRange') {
		$('#statsHolder').toggle();
		return false;
	} 

	$('.filterSelectors li').addClass('inactive');

	var pdfData = createGraphImage();		

	pdfData.tableFrag = 1;		
	$.post('/analytics/facility/print', pdfData, null, 'html')		
	.done(function(html){		
		$('#residents-table').replaceWith(html);
		$('.filterSelectors li').removeClass('inactive');		
	})

	if($(this).parent().children('.active').not('[data-print-filter="dateRange"]').length == 0){
		$('.relative-wrapper #residents').hide();
	}else{
		$('.relative-wrapper #residents').show();
	}

});

$(document).on('click', '#printGo', function(){
	if(isTour){
		$.powerTour('end');
		$('#steps-footer').animate({bottom: '-70px'},1000);
		$('#filter-wrap, #demo-filter').removeClass('powertour-highlight').removeClass('powertour-hook');
		isTour = false;
	}

	if($(this).attr('disabled') != undefined && $(this).attr('disabled') === true){
		return;
	}

	$('#report-preview .group td').each(function(i, td) {
		$('a', td).css('color', '#000000');
		$('span', td).each(function(j, span) {
			$(span).after('<br />');
			return false;
		});
	});


	var pdfData = createGraphImage(),
		chatBox = $('.relative-wrapper #chart-iamge'),
		statsBox = $('.relative-wrapper #statsHolder'),
		residentBox = $('.relative-wrapper #residents'),
		legendBox = $('#graphLegend');
	
	if(statsBox.children('ul').children().length == 0){
		statsBox.children('ul').remove();
		statsBox.find('#dateTexts').css('font-size', '15px');
	}
	pdfData.summary = $('#statsHolder').html();
	pdfData.dimensions = parseInt(chatBox.css('top')) + ':' + parseInt(chatBox.css('left')) + ':' + chatBox.width() + ':' + chatBox.height();
	pdfData.dimensions += ':' + parseInt(statsBox.css('top')) + ':' + parseInt(statsBox.css('left')) + ':' + statsBox.width() + ':' + statsBox.height();
	pdfData.dimensions += ':' + parseInt(residentBox.css('top')) + ':' + parseInt(residentBox.css('left')) + ':' + residentBox.width() + ':' + residentBox.height();
	pdfData.dimensions += ':' + parseInt(legendBox.css('top')) + ':' + parseInt(legendBox.css('left'));

	if(
	   mainGraphFilter == 'surveys' ||
	   mainGraphFilter == 'deficiencies' ||
	   mainGraphFilter == 'compare-star') {
		pdfData.residentBox = residentBox.html();
	}

	if(mainGraphFilter == 'compare-star' && mapImage != null){
		var mapImageElem = $('#mapImage');
		pdfData.mapImage = mapImage;
		pdfData.mapDimensions = parseFloat((mapImageElem.offset().top - ($('#residents').offset().top + $('#residents').height()))).toFixed(0) + ':' + parseInt(mapImageElem.parent().parent().css('left')) + ':' + mapImageElem.width() + ':' + mapImageElem.height();
	}

	removePopUpAndOverlay(undefined, true, 'noscroll');
	popUpMsgSimple('Generating your PDF, please wait.<p style="text-align:center;" class="ajax_loader"><img src="/assets/images/ajax-loader.gif" width="18" /></p>');

	printGraphWithData(pdfData);
});

jQuery.fn.outerHTML = function(s) {
return (s)
? this.before(s).remove()
: jQuery("&lt;p&gt;").append(this.eq(0).clone()).html();
}

function createGraphImage() {
	var serializer = new XMLSerializer();
	if($('#main-chart svg g.legend')[0] !== undefined) {
		var legendWidth = $('#main-chart svg g.legend')[0].getBoundingClientRect().width;
		var legendHeight = $('#main-chart svg g.legend')[0].getBoundingClientRect().height;
		var svgHTML = $('#main-chart svg g.legend').clone();
		svgHTML = serializer.serializeToString(svgHTML[0]);
		svgHTML = $(svgHTML).html();
		var legend = $('<svg width="'+(legendWidth + 2)+'" height="'+(legendHeight + 2)+'"><g style="font-size: 12px;">'+svgHTML+'</g></svg>').appendTo('#allPrintCanvas');
		$(legend).find('rect').attr('x', '0').attr('y', '0').css({'fill': 'white', 'stroke': 'black', 'opacity': '1'});
		$(legend).find('text').attr('x', 20).css({'font-size': '12px', 'font-family': 'sans-serif', 'shape-rendering': 'geometricPrecision', 'stroke-width': '0.5px'});
		$(legend).find('circle').attr('cx', 10);

		var y = 16;
		$.each($(legend).find('text'), function(index, value){
			$(this).attr('y', y);
			y += 12;
		});
		var y = 12;
		$.each($(legend).find('circle'), function(index, value){
			$(this).attr('cy', y);
			y += 12;
		});
		var canvgLegend = serializer.serializeToString($(legend)[0]);
		canvg('legendPrint', canvgLegend);

	}

	var mainChartClone = $('#main-chart svg').clone();
	$(mainChartClone).appendTo('#allPrintCanvas');
	var originalHeight = parseInt($(mainChartClone).attr('height'));
	var originalWidth = parseInt($(mainChartClone).attr('width'));
	var newWidth = 1200;
	var newHeight = originalHeight / originalWidth * newWidth;
	var moreHeight = $(mainChartClone).find('.bar-text');
	if(moreHeight.length > 0){
		moreHeight = moreHeight[0].getBBox().height;
		newHeight += moreHeight;
	}
	moreHeight = $(mainChartClone).find('.scales');
	if(moreHeight.length > 0){
		newHeight += 20;
	}
	$(mainChartClone).css({width: newWidth+'px', height: newHeight+'px', overflow: 'visible'});
	$(mainChartClone).find('g.legend').remove();

	$(mainChartClone).find('*').css({'font-size': '12px'});
	$(mainChartClone).find('.chart-body path.line').css({'fill': 'none', 'stroke-width': '2.5px'});
	$(mainChartClone).find('.chart-body path.area').css({'fill-opacity': '.5', 'stroke': 'none'});
	$.each($(mainChartClone).find('.chart-body path.area'), function(index, value){
		$(this).css('fill', $(value).attr('fill'));
	});
	$(mainChartClone).find('.grid-line').css({'fill': 'none', 'stroke': '#ccc', 'opacity': '0.5', 'shape-rendering': 'geometricPrecision'});
	$(mainChartClone).find('.grid-line line').css({'fill': 'none', 'stroke': '#ccc', 'opacity': '0.5', 'shape-rendering': 'geometricPrecision'});
	$(mainChartClone).find('.tick line').css({'fill': 'none', 'stroke': '#000', 'opacity': '1', 'shape-rendering': 'geometricPrecision'});
	$(mainChartClone).find('.tick text').css({'font-family': 'sans-serif', 'shape-rendering': 'geometricPrecision', 'stroke-width': '0.5px'}).each(function(){
		var svgString = serializer.serializeToString($(this)[0]);
		$(svgString).html($(svgString).html().toUpperCase());
	});
	$(mainChartClone).find('.axis').css({'stroke': '#000', 'stroke-width': '1px', 'fill': 'none'});
	$(mainChartClone).find('.tick').css({'fill': '#000'});


	if(mainGraphFilter == 'census'){
		$(mainChartClone).attr('transform', 'translate(20,0)');
	}


	canvg('mainGraphPrint', serializer.serializeToString($(mainChartClone)[0]), {scaleWidth: 1140});

	$(legend).remove();
	$(mainChartClone).remove();

	var legendImg = document.getElementById('legendPrint').toDataURL();
	var mainGraphImg = document.getElementById('mainGraphPrint').toDataURL();

	$('#legendPrint').remove();
	$('#mainGraphPrint').remove();
	$('#allPrintCanvas').append('<canvas id="legendPrint"></canvas><canvas id="mainGraphPrint"></canvas>');

	var from = $('#from').datepicker('getDate');
	var to = $('#to').datepicker('getDate');
	from = from.getTime() / 1000;
	to = to.getTime() / 1000;

	var get = [];
	if(mainDimension.top(Infinity).length > 0){
		for(var i = 0; i < mainDimension.top(Infinity).length; i++){
			if(mainGraphFilter == 'compare-star'){
				get.push(mainDimension.top(Infinity)[i].pro_uid);
			}else if(mainGraphFilter != 'surveys' && mainGraphFilter != 'qis' && mainGraphFilter != 'deficiencies'){
				get.push(mainDimension.top(Infinity)[i].id);
			}
		}
	}

	var summary = $('#percents').clone();
	$(summary).removeClass('powertour-hook').removeClass('powertour-highlight').find('.powertour-step').remove().end().appendTo('body');
	$(summary).find('.powertour-hook').removeClass('powertour-hook').end().find('.powertour-highlight').removeClass('powertour-highlight');
	var $currentFiltersPrint = $('#currentFilters').clone();
	$currentFiltersPrint.find('.powertour-step').remove();
	$currentFiltersPrint.find('.arrow-right').replaceWith('<img style="float:right;width:6px;height:12px;margin:0 5px 0 5px;vertical-align: middle;" src="/assets/images/arrow-filter.png" />');
    var filtersHTML = $currentFiltersPrint.html();
	var yOffset = $('#currentFilters').height();
	var pdfData = {
				mainImage: mainGraphImg,
				legend: legendImg,
				graphTitle: $('#mainFilterText').text(),
				from: from,
				to: to,
				rawRate: rawRate,
				adjustedRate: adjustedRate,
				get: JSON.stringify(get),
				summary: summary.html(),
				filters: filtersHTML,
				yOffset: (yOffset == 0 ? 35 : yOffset + 50 + 14)
			};
	summary.remove();
	$.each($('.pop_up .printForm input[checked]'), function(_, kv) {
	  pdfData[$(kv).attr('name')] = $(kv).attr('value');
	});

	if(usr_assoc_id != ''){
		pdfData['usr_assoc_id'] = usr_assoc_id;
	}
	return pdfData;
}


function printGraphWithData(data){

	data.genPdf = 1;


	$.post('/analytics/facility/print', data, null, 'json')
	.done(function(data){
		// $('body').prepend(data.htmlPreview);
		var bottomButtons = '<div class="text-right" id="popup_buttons">';
			bottomButtons += '<button id="cancelButton" onclick="removePopUpAndOverlay(undefined, true, \'noscroll\')">Cancel</button>'; //' <button id="printClone">Change Report</button>';
		bottomButtons += '</div>';
		$('body').addClass('relative');
	
		$('.msg_content').empty();
		$('.ajax_loader').remove();
	    $('.msg_content').append('To download your analytics PDF please <a href="/analytics/facility/pdf/' + data.link + '" target="_blank">click here</a>.</p>');
	})
	.fail(function(text){
		removePopUpAndOverlay();
	    popUpMsg('Something went wrong! Try again');
	});
}
